import React, { useEffect, useState, useRef } from "react";
import { Modal, Button,Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import ReactDatePicker from "react-datepicker";
import Tooltip from "react-bootstrap/Tooltip";
import RatingComponent from "../../../components/RatingComponent";
import RatingComponentWithoutNA from "../../../components/RatingComponentWithoutNA";
import Editor from "../../../components/editor";
import { API_URL } from "../../../constants";
import Select from "react-select";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import axios from "axios";
import validate from "./validate";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FileUploader } from "../../../components/MultipleFileUploader";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import CustomDatePicker from "../../../components/Custom-Datepicker-Type";
import CustomDatePickerIndex from "../../../components/Custom-Datepicker-Type-Index-Module";
import { FaSpinner } from "react-icons/fa";
import Accordion from "react-bootstrap/Accordion";
import CustomPhoneInput from "../../../components/phone-input";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { BsHandbag } from "react-icons/bs";
import ProfileInput from "../../../components/ProfilePic";
import { subYears, toDate } from "date-fns";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import EmployeeSchema from "./validationschema";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
const FIELD_TAB_MAPPING = {
  Title: { tabId: "general-tab", tabName: "General Details" },
  FirstName: { tabId: "general-tab", tabName: "General Details" },
  LastName: { tabId: "general-tab", tabName: "General Details" },
  Gender: { tabId: "general-tab", tabName: "General Details" },
  DateOfBirth: { tabId: "general-tab", tabName: "General Details" },
  MobileNo1: { tabId: "Contact-tab", tabName: "Contact Details" },
  EmergencyPhoneNo: { tabId: "Contact-tab", tabName: "Contact Details" },
  EmergencyContactName: { tabId: "Contact-tab", tabName: "Contact Details" },
  EmergencyContactRelation: { tabId: "Contact-tab", tabName: "Contact Details" },
  CorrespondenceAddress: { tabId: "Contact-tab", tabName: "Contact Details" },
  CorrespondenceState: { tabId: "Contact-tab", tabName: "Contact Details" },
  CorrespondenceCity: { tabId: "Contact-tab", tabName: "Contact Details" },
  CorrespondenceCountry: { tabId: "Contact-tab", tabName: "Contact Details" },
  PermanentAddress: { tabId: "Contact-tab", tabName: "Contact Details" },
  PermanentCity: { tabId: "Contact-tab", tabName: "Contact Details" },
  Qualification: { tabId: "Qualification-tab", tabName: "Qualification" },
  employeebank: { tabId: "Bank-tab", tabName: "Bank Details" },
  employeeAttachments: { tabId: "attachment-tab", tabName: "Attachments" },
  Identities: { tabId: "identities-tab", tabName: "Identity" },
  employment_history: { tabId: "employment-tab", tabName: "Employment Details" },
  PFNomineeName: { tabId: "additional-tab", tabName: "Additional Details" },
  PFNomineeRelation: { tabId: "additional-tab", tabName: "Additional Details" },
  BloodGroup: { tabId: "additional-tab", tabName: "Additional Details" },
  TotalYearExp: { tabId: "additional-tab", tabName: "Additional Details" },
  TotalMonthExp: { tabId: "additional-tab", tabName: "Additional Details" },
};

const AddEmployee = () => {
  const navigate = useNavigate();
  const modalRef = useRef(null);
  const { candidate_id } = useParams();
  const [pageLoading, setPageLoading] = useState(true);
  const [submit, setSubmit] = useState(false);
  let [errors, setErrors] = useState({});
  const [tabErrorCounts, setTabErrorCounts] = useState({});

  const switchTab = (tabId) => {
    const tabBtn = document.getElementById(tabId);
    if (tabBtn) {
      tabBtn.click();
      setTimeout(() => {
        tabBtn.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }, 150);
    }
  };

  // Draft persistence: keeps entered form data (including attachments and
  // the profile picture) in the browser so a failed submission doesn't
  // force the candidate to re-enter everything. Plain fields go to
  // localStorage; binary File data (attachments, profile picture) goes to
  // IndexedDB, since localStorage can't hold binary data and has a much
  // smaller quota.
  const DRAFT_STORAGE_KEY = `candidate_details_draft_${candidate_id}`;
  const ATTACHMENTS_DB_NAME = "candidate_details_attachments_db";
  const ATTACHMENTS_DB_VERSION = 2;
  const ATTACHMENTS_STORE_NAME = "attachments";
  const PROFILE_PIC_STORE_NAME = "profilePic";
  const draftRestoredRef = useRef(false);

  const getStorableFormData = (data) => {
    const { files, employeeAttachments, ProfilePic, ...rest } = data;
    return rest;
  };

  const saveDraft = (data) => {
    try {
      localStorage.setItem(
        DRAFT_STORAGE_KEY,
        JSON.stringify(getStorableFormData(data))
      );
    } catch (error) {
      console.error("Failed to save candidate details draft", error);
    }
    saveAttachmentsDraft(data.employeeAttachments);
    saveProfilePicDraft(data.ProfilePic);
  };

  const loadDraft = () => {
    try {
      const saved = localStorage.getItem(DRAFT_STORAGE_KEY);
      return saved ? JSON.parse(saved) : null;
    } catch (error) {
      console.error("Failed to load candidate details draft", error);
      return null;
    }
  };

  const clearDraft = () => {
    try {
      localStorage.removeItem(DRAFT_STORAGE_KEY);
    } catch (error) {
      console.error("Failed to clear candidate details draft", error);
    }
    clearAttachmentsDraft();
    clearProfilePicDraft();
  };

  const openAttachmentsDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(ATTACHMENTS_DB_NAME, ATTACHMENTS_DB_VERSION);
      request.onupgradeneeded = () => {
        if (!request.result.objectStoreNames.contains(ATTACHMENTS_STORE_NAME)) {
          request.result.createObjectStore(ATTACHMENTS_STORE_NAME);
        }
        if (!request.result.objectStoreNames.contains(PROFILE_PIC_STORE_NAME)) {
          request.result.createObjectStore(PROFILE_PIC_STORE_NAME);
        }
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  };

  const putInStore = async (storeName, value) => {
    try {
      const db = await openAttachmentsDB();
      await new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, "readwrite");
        tx.objectStore(storeName).put(value, candidate_id);
        tx.oncomplete = resolve;
        tx.onerror = () => reject(tx.error);
      });
    } catch (error) {
      console.error(`Failed to save draft to ${storeName}`, error);
    }
  };

  const getFromStore = async (storeName) => {
    try {
      const db = await openAttachmentsDB();
      return await new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, "readonly");
        const req = tx.objectStore(storeName).get(candidate_id);
        req.onsuccess = () => resolve(req.result ?? null);
        req.onerror = () => reject(req.error);
      });
    } catch (error) {
      console.error(`Failed to load draft from ${storeName}`, error);
      return null;
    }
  };

  const deleteFromStore = async (storeName) => {
    try {
      const db = await openAttachmentsDB();
      await new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, "readwrite");
        tx.objectStore(storeName).delete(candidate_id);
        tx.oncomplete = resolve;
        tx.onerror = () => reject(tx.error);
      });
    } catch (error) {
      console.error(`Failed to clear draft from ${storeName}`, error);
    }
  };

  const saveAttachmentsDraft = (employeeAttachments) =>
    putInStore(ATTACHMENTS_STORE_NAME, employeeAttachments || []);
  const loadAttachmentsDraft = () => getFromStore(ATTACHMENTS_STORE_NAME);
  const clearAttachmentsDraft = () => deleteFromStore(ATTACHMENTS_STORE_NAME);

  const saveProfilePicDraft = (profilePic) =>
    putInStore(PROFILE_PIC_STORE_NAME, profilePic instanceof File ? profilePic : null);
  const loadProfilePicDraft = () => getFromStore(PROFILE_PIC_STORE_NAME);
  const clearProfilePicDraft = () => deleteFromStore(PROFILE_PIC_STORE_NAME);

  let tableSelectStyle = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? "#212529" : provided.color,
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: state.isDisabled ? "#e9ecef" : provided.backgroundColor,
      opacity: state.isDisabled ? 1 : provided.opacity,
    }),
  };
  const initialFormData = {
    CandidateID: candidate_id,
    Title: "",
    FirstName: "",
    MiddleName: "",
    LastName: "",
    FatherName: "",
    FatherDOB: "",
    MotherName: "",
    MotherDOB: "",
    Active: 0,
    ProfilePic: "",
    Gender: "",
    DateOfBirth: "",
    MobileNo1: "",
    WhatappNo:"",
    MobileNo2: "",
    PersonalEmail: "",
    CorrepondenceAddressType: { label: "Correspondence", value: 823 },
    CorrespondenceAddress: "",
    CorrespondenceCity: "",
    CorrespondenceCityID: "",
    CorrespondenceState: "",
    CorrespondenceStateID: "",
    CorrespondenceCountry: "",
    CorrespondenceCountryID: "",
    CorrespondenceZip: "",
    CorrespondenceAddressPrint: "",
    CorrespondenceRawAddress: "",
    PermanentAddressType: { label: "Permanent", value: 822 },
    IsCopyAddress: 0,
    PermanentAddress: "",
    PermanentCity: "",
    PermanentCityID: "",
    PermanentState: "",
    PermanentStateID: "",
    PermanentCountry: "",
    PermanentCountryID: "",
    PermanentZip: "",
    PermanentAddressPrint: "",
    PermanentRawAddress: "",
    Qualification: [],
    Identities: [],
    employment_history: [{ OrganizationName: "", Location: "", StartDate: "", EndDate: "", Position: "", OfferLetter: null, OfferLetterPreview: null, SalarySlip: null, SalarySlipPreview: null, RelievingLetter: null, RelievingLetterPreview: null }],
    employeeAttachments: [],
    EmergencyContactName: "",
    EmergencyContactRelation: "",
    TotalYearExp:"",
    TotalMonthExp:"",
    MaritalStatus_021:"",
    SpouseName:"",
    SpouseDOB: "",
    Child1Name:"",
    Child1DOB: null,
    Child2Name:"",
    Child2DOB: null,
    BloodGroup: "",
    PFNomineeName: "",
    PFNomineeRelation: "",
    TADocumentVerify:0,


    files: [],
    old_pic_name: "",
    employeebank: [
    {
      LineNo: 1,
      ID: "",
      PayTo: "",
      Bank: "",
      Branch: "",
      AccountNo: "",
      IFSCCode: "",
      DefaultBank: 1,
    }
  ]
  };

  
  const [formData, setFormData] = useState(initialFormData);
  console.log("formData", formData);

  /* Setting data for components*/
  const [activeKey, setActiveKey] = useState("1");
  const [title, setTitles] = useState([]);
  const [contactType, setContactType] = useState([]);
  const [accountType, setAccountType] = useState([]);
  const [gendetType, setGenderType] = useState([]);
  const [bloodGroupType, setBloodGroupType] = useState([]);
  const [maritialStatus, setMaritialStatus] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [addressType, setAddressType] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [GSTRegType, setGSTRegType] = useState([]);
  const [relievingType, seteRlievingType] = useState([]);
  const [workingStatus, setWorkingStatus] = useState([]);
  const [leaveAcrualType, setLeaveAcrualType] = useState([]);
  const [referredBy, setReferredBy] = useState([]);
  const [nationality, setNationality] = useState([]);
  const [immediateManager, setImmediateManager] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [bankOptions, setbankOptions] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [department, setDepartment] = useState([]);
  const [employeeType, setEmployeeType] = useState([]);
   const [maritialStatusOptions, setMaritialStatusOptions] = useState([]);
  const [company, setCompany] = useState([]);
  const [relation, setRelation] = useState([]);
  const [identityType, setIdentityType] = useState([]);
  const [issuingContry, setIssuingCountry] = useState([]);
  const [profilePicError, setProfilePicError] = useState("");
  // A restored draft's ProfilePic is a raw File, not a URL, so build a
  // preview URL for it whenever it changes (covers both a fresh upload and
  // one restored from IndexedDB after a failed submission).
  const [profilePicPreview, setProfilePicPreview] = useState(null);
  useEffect(() => {
    if (formData.ProfilePic instanceof File) {
      const objectUrl = URL.createObjectURL(formData.ProfilePic);
      setProfilePicPreview(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    }
    setProfilePicPreview(null);
  }, [formData.ProfilePic]);
  const [showModal, setShowModal] = useState(false);
  const [currentDeleteParams, setCurrentDeleteParams] = useState(null);
  const [acknowledge, setAcknowledge] = useState(false);

  const [countryList, setCountryList] = useState([]);
  const handleShowModal = (e, type, category, index, line) => {
    setCurrentDeleteParams({ e, type, category, index, line });
    setShowModal(true);
  };
  console.log("SpouseDOB value:", formData?.SpouseDOB);

  const [deleteLoading, setDeleteLoading] = useState(false)

  const handleDelete = async () => {
    const { e, type, category, index } = currentDeleteParams;
    console.log("currentDeleteParams", currentDeleteParams);

    handleChangeWithIndex(e, type, category, index, "");
    if (category === "employeeAttachments") {
      try {
        let response
        setDeleteLoading(true)
        response = await PostServiceCaller(`${API_URL}delete-attachments/${candidate_id}`, { FileName: currentDeleteParams?.line.FileName }, "post")
        if (response?.status === 200) {
          toast.success("File Deleted Succesfully")
          setShowModal(false);
          setDeleteLoading(false)
        }
      } catch (error) {
        setDeleteLoading(false)
        console.error("Delete Attachment  Api Error", error);

      }
    }
  };

  /* Setting data for components end*/

  useEffect(() => {
    fetchDetails();
  }, []);

  // Persist a draft of the form data on every change, once the initial
  // fetch + any saved draft has been applied, so a failed submit (or an
  // accidental refresh) doesn't lose what the candidate already filled in.
  useEffect(() => {
    if (!draftRestoredRef.current) return;
    saveDraft(formData);
  }, [formData]);
  const fetchDetails = async () => {
    let response = await PostServiceCaller(
      API_URL + "fetch-candidate-details",
      { candidate_id: candidate_id },
      "post"
    );
    if (response?.data?.status == "success") {
      // title option
      const titlesOpt = response?.data?.data?.titles?.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setTitles(titlesOpt);
      setPageLoading(false);
      // contact type option
      const contactTypeOpt = response?.data?.data?.contact_type?.map(
        (option) => ({
          label: option.text,
          value: option.value,
        })
      );
      setContactType(contactTypeOpt);
      // account type
      const accountTypeOpt = response?.data?.data?.account_type?.map(
        (option) => ({
          label: option.text,
          value: option.value,
        })
      );
      setAccountType(accountTypeOpt);
      //Maritial Status
      const maritialStatusOptions = response?.data?.data?.maritial_status?.map(
        (option) => ({
          label: option.text,
          value: option.value,
        })
      );
      setMaritialStatusOptions(maritialStatusOptions);
      // Gender type
      const genderTypeOpt = response?.data?.data?.gender?.map((option) => ({
        label: option.text,
        value: option.value,
      }));

      setGenderType(genderTypeOpt);
      // Blood Group Type
      const bloodGroupTypeOpt = response.data.data.blood_group.map(
        (option) => ({
          label: option.text,
          value: option.value,
        })
      );
      setBloodGroupType(bloodGroupTypeOpt);
      const bankOptions = response.data.data.banks.map(
        (option) => ({
          label: option.text,
          value: option.value,
        })
      );
      setbankOptions(bankOptions);
      // set marital status
      const maritialStatusOpt = response.data.data.maritial_status.map(
        (option) => ({
          label: option.text,
          value: option.value,
        })
      );
      setMaritialStatus(maritialStatusOpt);
      // branch list
      const branchListOpt = response.data.data.branches.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setBranchList(branchListOpt);
      // Address Type
      const addressTypeOpt = response.data.data.addressType.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setAddressType(addressTypeOpt);
      // City list
      const countryListOpt = response.data.data.country.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setCountryList(countryListOpt);
      // GST Reg Type
      const gstRegTypeOpt = response.data.data.gstRegType.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setGSTRegType(gstRegTypeOpt);
      // Relieving Type
      const relievingTypeOpt = response.data.data.relievingType.map(
        (option) => ({
          label: option.text,
          value: option.value,
        })
      );
      seteRlievingType(relievingTypeOpt);
      // working status
      const workingStatusOpt = response.data.data.workingStatus.map(
        (option) => ({
          label: option.text,
          value: option.value,
        })
      );
      setWorkingStatus(workingStatusOpt);
      // leave acrual type
      const leaveAcrualTypeOpt = response.data.data.leaveAcrualType.map(
        (option) => ({
          label: option.text,
          value: option.value,
        })
      );
      setLeaveAcrualType(leaveAcrualTypeOpt);
      // referred by
      const referredByOpt = response.data.data.referredBy.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setReferredBy(referredByOpt);
      // nationality
      const nationalityOpt = response.data.data.nationality.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setNationality(nationalityOpt);
      // immediate manager
      const immediateManagerOpt = response.data.data.immediate_manager.map(
        (option) => ({
          label: option.text,
          value: option.value,
        })
      );
      setImmediateManager(immediateManagerOpt);
      // shifts
      const shiftsOpt = response.data.data.shifts.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setShifts(shiftsOpt);
      // designation
      const designationOpt = response.data.data.designation.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setDesignation(designationOpt);
      // department
      const departmentOpt = response.data.data.department.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setDepartment(departmentOpt);
      // employee type
      const employeeTypeOpt = response.data.data.employee_type.map(
        (option) => ({
          label: option.text,
          value: option.value,
        })
      );
      setEmployeeType(employeeTypeOpt);
      // const company
      const companyOpt = response.data.data.company.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setCompany(companyOpt);
      // relation
      const relationOpt = response.data.data.relationType.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setRelation(relationOpt);
      //identity type
      const identityOpt = response.data.data.identityType.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setIdentityType(identityOpt);
      // issuing Country
      const issuingContryOpt = response.data.data.identityIssueingCountry.map(
        (option) => ({
          label: option.text,
          value: option.value,
        })
      );
      setIssuingCountry(issuingContryOpt);
      // setting candidate data
      let selected_geneder = genderTypeOpt?.find(
        (o) => o.value == response.data.data.candidate_details.Gender_020
      );
      if (response.data.data.details_already_exits) {
        const fetchedCandidateData = {
          ...formData,
          Title: response.data.data.candidate_details.Title,
          FirstName: response.data.data.candidate_details.FirstName,
          MiddleName: response.data.data.candidate_details.MiddleName,
          LastName: response.data.data.candidate_details.LastName,
          FatherName: response.data.data.candidate_details.FatherName,
          FatherDOB: response.data.data.candidate_details.FatherDOB || "",
          MotherName: response.data.data.candidate_details.MotherName,
          MotherDOB: response.data.data.candidate_details.MotherDOB || "",
          Active: response.data.data.candidate_details.Active,
          OldProfilePic: response.data.data.candidate_details.ProfilePicUrl,
          ProfilePic: response.data.data.candidate_details.ProfilePic,
          old_pic_name: response.data.data.candidate_details.ProfilePic,
          Gender: response.data.data.candidate_details.Gender,
          DateOfBirth: response.data.data.candidate_details.DateOfBirth,
          MobileNo1: response.data.data.candidate_details.MobileNo1 || null,
          WhatappNo: response.data.data.candidate_details.WhatappNo || null,
          MobileNo2: response.data.data.candidate_details.MobileNo2 || "",
          PersonalEmail: response.data.data.candidate_details.PersonalEmail,
          CorrepondenceAddressType: { label: "Correspondence", value: 823 },
          CorrespondenceAddress:
            response.data.data.candidate_details.CorrespondenceAddress,
          CorrespondenceCity:
            response.data.data.candidate_details.CorrespondenceCity,
          CorrespondenceCityID: response.data.data.candidate_details.CorrespondenceCityID,
          CorrespondenceState:
            response.data.data.candidate_details.CorrespondenceState,
          CorrespondenceStateID:
            response.data.data.candidate_details.CorrespondenceStateID,
          CorrespondenceCountry:
            response.data.data.candidate_details.CorrespondenceCountry,
          CorrespondenceCountryID: response.data.data.candidate_details.CorrespondenceCountryID,
          CorrespondenceZip:
            response.data.data.candidate_details.CorrespondenceZip,
          CorrespondenceAddressPrint:
            response.data.data.candidate_details.CorrespondenceAddressPrint,
          CorrespondenceRawAddress:
            response.data.data.candidate_details.CorrespondenceRawAddress,
          PermanentAddressType: { label: "Permanent", value: 822 },
          IsCopyAddress:
            response.data.data.candidate_details.CorrespondenceAddressPrint ==
              response.data.data.candidate_details.PermanentAddressPrint
              ? 1
              : 0,
          PermanentAddress:
            response.data.data.candidate_details.PermanentAddress,
          PermanentCity: response.data.data.candidate_details.PermanentCity,
          PermanentCityID: response.data.data.candidate_details.PermanentCityID,
          PermanentState: response.data.data.candidate_details.PermanentState,
          PermanentStateID: response.data.data.candidate_details.PermanentStateID,
          PermanentCountry:
            response.data.data.candidate_details.PermanentCountry,
          PermanentCountryID: response.data.data.candidate_details.PermanentCountryID,
          PermanentZip: response.data.data.candidate_details.PermanentZip,
          PermanentAddressPrint:
            response.data.data.candidate_details.PermanentAddressPrint,
          PermanentRawAddress:
            response.data.data.candidate_details.PermanentRawAddress,
          Qualification: response.data.data.candidate_details.Qualification,
          employeebank: response.data.data.candidate_details.employeebank && 
                response.data.data.candidate_details.employeebank.length > 0 
                ? response.data.data.candidate_details.employeebank.map((bank, idx) => ({
                    ...bank,
                    LineNo: idx + 1, // Ensure LineNo is set properly
                    ID: bank.ID || "",
                    PayTo: bank.PayTo || "",
                    Bank: bank.Bank,
                    Branch: bank.Branch || "",
                    AccountNo: bank.AccountNo || "",
                    IFSCCode: bank.IFSCCode || "",
                    DefaultBank: bank.DefaultBank === "1" || bank.DefaultBank === 1 ? 1 : 0,
                  }))
                : [{
                    LineNo: 1,
                    ID: "",
                    PayTo: "",
                    Bank: "",
                    Branch: "",
                    AccountNo: "",
                    IFSCCode: "",
                    DefaultBank: 1,
                  }],
          Identities: response.data.data.candidate_details.Identities,
          employment_history: response.data.data.candidate_details.employment_history?.length > 0 
            ? response.data.data.candidate_details.employment_history 
            : [{ OrganizationName: "", Location: "", StartDate: "", EndDate: "", Position: "" }],
          TotalYearExp: response.data.data.candidate_details.TotalYearExp,
          TotalMonthExp: response.data.data.candidate_details.TotalMonthExp,
          BloodGroup: response.data.data.candidate_details.BloodGroup || "",
          PFNomineeName: response.data.data.candidate_details.PFNomineeName || "",
          PFNomineeRelation: response.data.data.candidate_details.PFNomineeRelation || "",
          MaritalStatus_021: response.data.data.candidate_details.MaritalStatus_021 
                   ? parseInt(response.data.data.candidate_details.MaritalStatus_021) 
                   : "",
          SpouseName: response.data.data.candidate_details.SpouseName || null,
          SpouseDOB: response.data.data.candidate_details.SpouseDOB && response.data.data.candidate_details.SpouseDOB !== "" ? moment(response.data.data.candidate_details.SpouseDOB).format("DD-MMM-YYYY") : null,
          Child1Name: response.data.data.candidate_details.Child1Name || null,
          Child1DOB: response.data.data.candidate_details.Child1DOB || null,
          Child2Name: response.data.data.candidate_details.Child2Name || null,
          Child2DOB: response.data.data.candidate_details.Child2DOB || "",
          employeeAttachments:
            response.data.data.candidate_details.employeeAttachments,
          files: response.data.data.candidate_details.files,
          EmergencyPhoneNo:
            response.data.data.candidate_details.EmergencyPhoneNo || "",
          EmergencyContactName:
            response.data.data.candidate_details.EmergencyContactName || "",
          EmergencyContactRelation:
            response.data.data.candidate_details.EmergencyContactRelation || "",
        };
        // A locally saved draft (from a previous failed submission) takes
        // precedence over the server-fetched defaults, so in-progress edits
        // aren't lost. Attachments and the profile picture are stored
        // separately in IndexedDB (they hold raw File objects, which
        // localStorage can't hold).
        const [savedAttachments, savedProfilePic] = await Promise.all([
          loadAttachmentsDraft(),
          loadProfilePicDraft(),
        ]);
        const mergedCandidateData = {
          ...fetchedCandidateData,
          ...(loadDraft() || {}),
          ...(savedAttachments && savedAttachments.length > 0
            ? {
                employeeAttachments: savedAttachments,
                // Only entries added locally (not yet uploaded) carry a
                // real File; pre-existing server attachments have no
                // `.file` and must be excluded here, or `files` would end
                // up with `undefined` in place of those.
                files: savedAttachments
                  .filter((a) => a.file instanceof File)
                  .map((a) => a.file),
              }
            : {}),
          ...(savedProfilePic instanceof File
            ? { ProfilePic: savedProfilePic }
            : {}),
        };
        setFormData(mergedCandidateData);
        draftRestoredRef.current = true;
        // Populate the state/city dropdown options to match whatever
        // country/state ended up in the merged data (draft or server), so
        // the Select components can resolve their selected value.
        if (mergedCandidateData.CorrespondenceCountryID != null) {
          fetchState(mergedCandidateData.CorrespondenceCountryID);
        }
        if (mergedCandidateData.CorrespondenceStateID != null) {
          fetchCity(mergedCandidateData.CorrespondenceStateID);
        }
        // setting up error array for line level data
        let qualification_errors = [];
        for (
          let i = 0;
          i < response.data.data.candidate_details.Qualification?.length;
          i++
        ) {
          qualification_errors.push({
            Type: { status: false, message: "" },
            Name: { status: false, message: "" },
            University: { status: false, message: "" },
          });
        }
         let bank_errors = [];
        for (
          let i = 0;
          i < response.data.data.candidate_details.employeebank?.length;
          i++
        ) {
          bank_errors.push({
            AccountNo: { status: false, message: "" },
            Bank: { status: false, message: "" },
            Branch: { status: false, message: "" },
            IFSCCode: { status: false, message: "" },
            LineNo: { status: false, message: "" },
          });
        }
        let identites_error = [];
        for (
          let i = 0;
          i < response.data.data.candidate_details.Identities?.length;
          i++
        ) {
          identites_error.push({
            Type: { status: false, message: "" },
            Name: { status: false, message: "" },
            Number: { status: false, message: "" },
            Country: { status: false, message: "" },
          });
        }
        setErrors({
          ...errors,
          Identities: identites_error,
          Qualification: qualification_errors,
          Bank: bank_errors
        });
      } else {
        const aadharType = identityOpt.find(opt => opt.label?.toLowerCase().includes('aadhar'));
        const panType = identityOpt.find(opt => opt.label?.toLowerCase().includes('pan'));
        const passportType = identityOpt.find(opt => opt.label?.toLowerCase().includes('passport'));

        const defaultIdentities = [];
        if (aadharType) defaultIdentities.push({ Type: aadharType, Name: "", Number: "", Country: "", issueDate: "", expiryDate: "", isDefault: true });
        if (panType) defaultIdentities.push({ Type: panType, Name: "", Number: "", Country: "", issueDate: "", expiryDate: "", isDefault: true });
        if (passportType) defaultIdentities.push({ Type: passportType, Name: "", Number: "", Country: "", issueDate: "", expiryDate: "", isDefault: true });

        const defaultQualifications = [
          { Type: "SSC", Qualification: "", Stream: "", Institute: "", Year: "", Percentage: "", University: "", QualificationFile: null, QualificationFilePreview: null, isDefault: true },
          { Type: "HSC/Diploma", Qualification: "", Stream: "", Institute: "", Year: "", Percentage: "", University: "", QualificationFile: null, QualificationFilePreview: null, isDefault: true },
          { Type: "Graduation", Qualification: "", Stream: "", Institute: "", Year: "", Percentage: "", University: "", QualificationFile: null, QualificationFilePreview: null, isDefault: true },
        ];

        setFormData({
          ...formData,
          FirstName: response.data.data.candidate_details?.FirstName,
          LastName: response.data.data.candidate_details?.LastName,
          DateOfBirth: response.data.data.candidate_details?.DateOfBirth ? moment(
            response.data.data.candidate_details.DateOfBirth
          ).format("DD-MMM-YYYY") : "",
          MobileNo1: response.data.data.candidate_details?.MobileNo
            ? response?.data?.data?.candidate_details?.MobileNo
            : null,
          MobileNo2: response.data.data.candidate_details?.MobileNo1
            ? response?.data?.data?.candidate_details?.MobileNo1
            : null,
          PersonalEmail: response.data.data.candidate_details?.EmailID,
          Gender: selected_geneder,
          Identities: defaultIdentities,
          Qualification: defaultQualifications,
        });
        
        let identites_error = defaultIdentities.map(() => ({
          Type: { status: false, message: "" },
          Name: { status: false, message: "" },
          Number: { status: false, message: "" },
          Country: { status: false, message: "" },
        }));

        let qualification_error = defaultQualifications.map(() => ({
          Type: { status: false, message: "" },
          Qualification: { status: false, message: "" },
          Stream: { status: false, message: "" },
          Institute: { status: false, message: "" },
          Year: { status: false, message: "" },
          Percentage: { status: false, message: "" },
          University: { status: false, message: "" },
        }));

        setErrors(prev => ({ ...prev, Identities: identites_error, Qualification: qualification_error }));
      }
    } else if (response?.data?.status == "failed") {
      navigate("/link-expired");
    }
  };

  // when user click link pdf will open
  const openPdf = (file) => {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, "_blank");
  };
   
  const handleAddLine = (e, arrayName, defaultRowStructure, keyToCheck) => {
      e.preventDefault();
      console.log(
        "defaultRowStructure",
        e,
        arrayName,
        defaultRowStructure,
        keyToCheck
      );
  
      // Get the last row in the specified array
      const currentArray = formData[arrayName] || []; // Default to an empty array if undefined
      const currentRow =
        currentArray.length !== 0 ? currentArray[currentArray.length - 1] : null;
  
      // vaidation Add in Location History
      if (arrayName === 'empLocation' && currentArray.length > 0) {
        const lastRow = currentArray[currentArray.length - 1];
  
        const requiredFields = ['CityID', 'FromDate', 'ToDate'];
        const isIncomplete = requiredFields.some(field =>
          !lastRow[field] || lastRow[field] === ""
        );
  
        if (isIncomplete) {
          toast.error("Please fill all fields in the current row before adding a new one");
          return;
        }
      }
  
  
      // Find the smallest missing line number
      let newLineNo =
        currentArray.length > 0
          ? Math.max(...currentArray.map((row) => row.LineNo)) + 1
          : 1;
  
      // Log the new line number for debugging
      console.log(`Adding row to ${arrayName} with LineNo:`, newLineNo);
  
      // Create a new row with dynamic structure
      const newRow = {
        LineNo: newLineNo,
        ID: "",
        AccountNo: "",
        Bank: "",
        IFSCCode: "",
        Branch: "",
        DefaultBank: 1,
      };
  
      // Ensure prevState[arrayName] is always an array
      setFormData((prevState) => ({
        ...prevState,
        [arrayName]: [...(prevState[arrayName] || []), newRow], // Fix: Ensure it's an array
      }));
    };
    const handleAllLineChange = async (e, index, section) => {
      const { name, type, checked, value } = e.target;
      const updatedSection = [...formData[section]];
      const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;
      if (name === "DefaultBank" && newValue === 1) {
        const alreadySelected = updatedSection.find(
          (item, idx) => item.DefaultBank === 1 && idx !== index
        );
        if (alreadySelected) {
          toast.error("Only one Default Bank can be selected.");
          return; // Block further execution
        }
      }
      updatedSection[index][name] = newValue;
  
      try {

        // Update form state and clear errors if valid
        setFormData((prevState) => ({
          ...prevState,
          [section]: updatedSection,
        }));
        setErrors((prevErrors) => ({
          ...prevErrors,
          [section]: {
            ...prevErrors[section],
            [index]: { ...prevErrors[section]?.[index], [name]: "" },
          },
        }));
      } catch (err) {
        // Set validation error message
        setErrors((prevErrors) => ({
          ...prevErrors,
          [section]: {
            ...prevErrors[section],
            [index]: { ...prevErrors[section]?.[index], [name]: err.message },
          },
        }));
      }
    };

     const handleLineSelect = async (selectedOption, name, index, section) => {
    console.log("select---->", selectedOption, name, section, index);
    const updatedSection = [...formData[section]];
    updatedSection[index][name] = selectedOption.value;
    // Update both CityID and CityName when CityID is selected
    if (name === "CityID") {
      updatedSection[index]["CityName"] = selectedOption.label;
    }
    try {
      // Update form state and clear errors if valid
      setFormData((prevState) => ({
        ...prevState,
        [section]: updatedSection,
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        [section]: {
          ...prevErrors[section],
          [index]: {
            ...prevErrors[section]?.[index],
            [name]: "",
            ...(name === "CityID" && { CityName: "" }),
          },
        },
      }));
    } catch (err) {
      // Set validation error message
      setErrors((prevErrors) => ({
        ...prevErrors,
        [section]: {
          ...prevErrors[section],
          [index]: {
            ...prevErrors[section]?.[index],
            [name]: err.message,
            ...(name === "CityID" && { CityName: err.message }),
          },
        },
      }));
    }
  };
  const handleSelect = (selectedOption, name) => {
    const value = selectedOption ? selectedOption.value : "";

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (value) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: { status: false, message: "" },
      }));
    }
  };

  const deleteLine = (e, arrayName, lineNoToDelete) => {
    e.preventDefault();

    setFormData((prevState) => ({
      ...prevState,
      [arrayName]: prevState[arrayName].filter(
        (row) => row.LineNo !== lineNoToDelete
      ),
    }));
  };
  

  /* Handle Change Start */
  const handleChange = async (e, name, type, required = []) => {


    console.log("e, name, type, required", e, name, type, required);

    switch (type) {
      case "dropdown":
        setFormData({ ...formData, [name]: e });
        break;

      case "input":
        setFormData({ ...formData, [name]: e.target.value });
        break;
      case "input-submit":
        setFormData({ ...formData, [name]: e.target.value });
        break;

      case "mobile":
        setFormData({ ...formData, [name]: e.target.value });
        break;

      case "radio":
        let checkBoxValue = e.target.value;
        let flag = checkBoxValue === "No" ? 1 : 0;
        setFormData({ ...formData, [name]: flag });
        break;

      case "datepicker":
        setFormData({ ...formData, [name]: e || "" });
        break;

      case "checkbox":
        setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
        break;

      case "country":
        setFormData({ ...formData, [name]: e });
        fetchState(e.value);
        if (name === "CorrespondenceCountry") {
          setFormData({
            ...formData,
            CorrespondenceCountry: e,
            CorrespondenceCountryID: e.value,
          });
          setErrors((prevErrors) => ({
            ...prevErrors,
            CorrespondenceCountry: { status: false, message: "" },
          }));
        } else {
          setFormData({
            ...formData,
            PermanentCountry: e,
            PermanentCountryID: e.value,
          });
        }
        break;

      case "state":
        setFormData({ ...formData, [name]: e });

        fetchCity(e.value);
        if (name === "CorrespondenceState") {
          setFormData({
            ...formData,
            CorrespondenceState: e,
            CorrespondenceStateID: e.value,
            // CorrespondenceCountry: stateResponse.data.country,
            // CorrespondenceCountryID: stateResponse.data.country.CountryID,
          });
          setErrors((prevErrors) => ({
            ...prevErrors,
            CorrespondenceStateID: { status: false, message: "" },
          }));
        } else {
          setFormData({
            ...formData,
            PermanentState: e,
            PermanentStateID: e.value,
            // PermanentCountry: stateResponse.data.country,
            // PermanentCountryID: stateResponse.data.country.CountryID,
          });
        }
        break;
      case "city":
        setFormData({ ...formData, [name]: e });
        const addressResponse = await PostServiceCaller(
          `${API_URL}fetch-address-details`,
          { AreaCode: e.label },
          "post"
        );

        // PostServiceCaller resolves to undefined on a failed request
        // (network error, 5xx, etc.) - bail out instead of crashing on
        // addressResponse.data below.
        const addressDetails = addressResponse?.data?.address;
        if (!addressDetails) {
          toast.error("Failed to fetch address details. Please try again.");
          break;
        }

        if (name === "CorrespondenceCity") {
          let printAddress = formData.CorrespondenceAddress
            ? formData.CorrespondenceAddress + ", "
            : "";
          if (addressDetails.PrintAddress) {
            printAddress += addressDetails.PrintAddress;
          }
          if (formData.CorrespondenceZip) {
            printAddress += ", " + formData.CorrespondenceZip;
          }

          setFormData({
            ...formData,
            // CorrespondenceState: addressDetails.state,
            CorrespondenceAddressPrint: printAddress,
            // CorrespondenceCountry: addressDetails.Country,
            CorrespondenceCity: e,
            CorrespondenceRawAddress: addressDetails.PrintAddress,
            CorrespondenceCityID: addressDetails.CityID,
            // CorrespondenceStateID: addressDetails.StateID,
            // CorrespondenceCountryID: addressDetails.CountryID,
          });
        } else {
          let printAddress = formData.PermanentAddress
            ? formData.PermanentAddress + ", "
            : "";
          if (addressDetails.PrintAddress) {
            printAddress += addressDetails.PrintAddress;
          }
          if (formData.PermanentZip) {
            printAddress += ", " + formData.PermanentZip;
          }

          setFormData({
            ...formData,
            PermanentState: addressDetails.state,
            PermanentAddressPrint: printAddress,
            PermanentCountry: addressDetails.Country,
            PermanentCity: e,
            PermanentRawAddress: addressDetails.PrintAddress,
            PermanentCityID: addressDetails.CityID,
            PermanentStateID: addressDetails.StateID,
            PermanentCountryID: addressDetails.CountryID,
          });
        }
        break;

      case "checkbox-copy":
        let copyBoxValue = e.target.checked ? 1 : 0;
        setFormData({ ...formData });
        if (
          e.target.checked &&
          formData.CorrespondenceCity &&
          formData.CorrespondenceAddress !== ""
        ) {
          // Copy address from Correspondence
          setFormData({
            ...formData,
            IsCopyAddress: copyBoxValue,
            PermanentAddress: formData.CorrespondenceAddress,
            PermanentCity: formData.CorrespondenceCity,
            PermanentCountry: formData.CorrespondenceCountry,
            PermanentState: formData.CorrespondenceState,
            PermanentZip: formData.CorrespondenceZip,
            PermanentAddressPrint: formData.CorrespondenceAddressPrint,
            PermanentRawAddress: formData.CorrespondenceRawAddress,
            PermanentCityID: formData.CorrespondenceCityID,
            PermanentStateID: formData.CorrespondenceStateID,
            PermanentCountryID: formData.CorrespondenceCountryID,
          });

          // Clear validation errors for permanent fields
          setErrors((prevErrors) => {
            const { PermanentAddress, PermanentCity, ...rest } = prevErrors;
            return rest;
          });
        } else {
          // Clear copied fields
          setFormData({
            ...formData,
            IsCopyAddress: copyBoxValue,
            PermanentAddress: "",
            PermanentCity: "",
            PermanentCountry: "",
            PermanentState: "",
            PermanentZip: "",
            PermanentAddressPrint: "",
            PermanentRawAddress: "",
            PermanentCityID: "",
            PermanentStateID: "",
            PermanentCountryID: "",
          });

          setErrors((prevErrors) => {
            const { PermanentAddress, PermanentCity, ...rest } = prevErrors;
            return rest;
          });
        }
        break;
    }

    // Validation block
    if (required?.length > 0) {
      let error = validate(e, required, type);
      setErrors((o) => ({ ...o, [name]: error }));
    }
  };

  const [stateList, setStateList] = useState([]);
  const fetchState = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-state-city/${id}`
      );
      if (response.status === 200) {
        const cleanedData = response?.data?.StateCity || [];
        const options = cleanedData.map((record) => ({
          value: record.value,
          label: record.text,
        }));

        setStateList(options);
      } else {
        console.error(
          "Failed to fetch states. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    } finally {
      setPageLoading(false);
    }
  };

  const fetchCity = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-state-city/${id}`
      );
      if (response.status === 200) {
        const cleanedData = response?.data?.StateCity || [];

        const options = cleanedData.map((record) => ({
          value: record.value,
          label: record.text,
        }));

        setCityList(options);
      } else {
        console.error(
          "Failed to fetch cities. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    } finally {
      setPageLoading(false);
    }
  };
  /* Handle Change End*/
  /* Update Address Function Start*/
  const updateAddress = (e, name, type) => {
    let printAddress = "";
    if (name == "CorrespondenceAddress" || name == "CorrespondenceZip") {
      switch (type) {
        case "Address":
          if (e.target.value != "") {
            printAddress = e.target.value + ", ";
          }
          if (formData.CorrespondenceRawAddress != "") {
            printAddress = printAddress + formData.CorrespondenceRawAddress;
          }
          if (formData.CorrespondenceZip != "") {
            printAddress = printAddress + ", " + formData.CorrespondenceZip;
          }

          break;
        case "Zipcode":
          if (formData.CorrespondenceAddress != "") {
            printAddress = formData.CorrespondenceAddress + ", ";
          }
          if (formData.CorrespondenceRawAddress != "") {
            printAddress = printAddress + formData.CorrespondenceRawAddress;
          }
          if (e.target.value != "") {
            printAddress = printAddress + ", " + e.target.value;
          }
          break;
      }
      setFormData({
        ...formData,
        CorrespondenceAddressPrint: printAddress.toLocaleUpperCase(),
      });
    } else {
      switch (type) {
        case "Address":
          if (e.target.value != "") {
            printAddress = e.target.value + ", ";
          }
          if (formData.PermanentRawAddress != "") {
            printAddress = printAddress + formData.PermanentRawAddress;
          }
          if (formData.PermanentZip != "") {
            printAddress = printAddress + ", " + formData.PermanentZip;
          }

          break;
        case "Zipcode":
          if (formData.PermanentAddress != "") {
            printAddress = formData.PermanentAddress + ", ";
          }
          if (formData.PermanentRawAddress != "") {
            printAddress = printAddress + formData.PermanentRawAddress;
          }
          if (e.target.value != "") {
            printAddress = printAddress + ", " + e.target.value;
          }
          break;
      }
      setFormData({ ...formData, PermanentAddressPrint: printAddress });
    }
  };
  /* Update Address Function end*/
  /* Handle Change with index and module*/
  const handleIdentityFileChange = (files, index) => {
    if (!files || files.length === 0) return;

    const file = files[0];

    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG, PNG and PDF files are allowed.");
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5 MB

    if (file.size > maxSize) {
      toast.error("File size should not exceed 5MB.");
      return;
    }
    
    setFormData((prev) => {
      const Identities = [...prev.Identities];

      Identities[index] = {
        ...Identities[index],
        IdentityFile: file,
        IdentityFilePreview: URL.createObjectURL(file),
      };

      return {
        ...prev,
        Identities,
      };
    });
  };

  const handleEmploymentFileChange = (files, index, fileType) => {
    if (!files || files.length === 0) return;

    const file = files[0];

    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG, PNG and PDF files are allowed.");
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5 MB

    if (file.size > maxSize) {
      toast.error("File size should not exceed 5MB.");
      return;
    }
    
    setFormData((prev) => {
      const employment_history = [...prev.employment_history];

      employment_history[index] = {
        ...employment_history[index],
        [fileType]: file,
        [`${fileType}Preview`]: URL.createObjectURL(file),
      };

      return {
        ...prev,
        employment_history,
      };
    });
  };

  const handleQualificationFileChange = (files, index) => {
    if (!files || files.length === 0) return;

    const file = files[0];

    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG, PNG and PDF files are allowed.");
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5 MB

    if (file.size > maxSize) {
      toast.error("File size should not exceed 5MB.");
      return;
    }
    
    setFormData((prev) => {
      const Qualification = [...prev.Qualification];

      Qualification[index] = {
        ...Qualification[index],
        QualificationFile: file,
        QualificationFilePreview: URL.createObjectURL(file),
      };

      return {
        ...prev,
        Qualification,
      };
    });
  };

  const handleChangeWithIndex = (
    value,
    type,
    module,
    index,
    name,
    required = []
  ) => {
    if (required?.length > 0) {
      let error = validate(value, required, type);
      setErrors((prevErrors) => {
        let errorArray = Array.isArray(prevErrors[module])
          ? [...prevErrors[module]]
          : [];
        if (!errorArray[index]) {
          errorArray[index] = {};
        }
        errorArray[index][name] = error;
        return { ...prevErrors, [module]: errorArray };
      });
    }

    setFormData((prev) => {
      let array = prev[module] ? [...prev[module]] : [];

      if (type !== "remove" && type !== "addRow") {
        array[index] = { ...array[index] };
      }

      switch (type) {
        case "input-submit":
        case "input":
          array[index][name] = value?.target?.value;
          break;
        case "dropdown":
        case "datepicker":
          array[index][name] = value;
          break;
        case "remove":
          array.splice(index, 1);
          break;

        case "addRow":
          value.preventDefault();
          switch (module) {
            case "employment_history":
              array.push({
                OrganizationName: "",
                Location: "",
                StartDate: "",
                EndDate: "",
                Position: "",
                OfferLetter: null,
                OfferLetterPreview: null,
                SalarySlip: null,
                SalarySlipPreview: null,
                RelievingLetter: null,
                RelievingLetterPreview: null,
              });
              setErrors((prevErrors) => {
                let errArray = prevErrors?.employment_history || [];
                errArray.push({
                  OrganizationName: { status: false, message: "" },
                  Location: { status: false, message: "" },
                  StartDate: { status: false, message: "" },
                  EndDate: { status: false, message: "" },
                  Position: { status: false, message: "" },
                });
                return { ...prevErrors, employment_history: errArray };
              });
              break;
            case "workingAreas":
              array.push({
                employeeType: "",
                branch: "",
                company: "",
              });
              setErrors((prevErrors) => {
                let errArray = prevErrors?.workingAreas || [];
                errArray.push({
                  employeeType: { status: false, message: "" },
                  branch: { status: false, message: "" },
                  company: { status: false, message: "" },
                });
                return { ...prevErrors, workingAreas: errArray };
              });
              break;
            case "RelationTypeAndGroup":
              array.push({
                Relation: "",
                Contact: "",
              });
              setErrors((prevErrors) => {
                let errArray = prevErrors?.RelationTypeAndGroup || [];
                errArray.push({
                  Relation: { status: false, message: "" },
                  Contact: { status: false, message: "" },
                });
                return { ...prevErrors, RelationTypeAndGroup: errArray };
              });
              break;
            case "Qualification":
              array.push({
                Type: "",
                Qualification: "",
                Stream: "",
                Institute: "",
                University: "",
                Percentage: "",
                YearOfPassing: "",
                QualificationFile: "",
                QualificationFilePreview: "",
              });
              setErrors((prevErrors) => {
                let errArray = prevErrors?.Qualification || [];
                errArray.push({
                  Type: { status: false, message: "" },
                  Name: { status: false, message: "" },
                  University: { status: false, message: "" },
                });
                return { ...prevErrors, Qualification: errArray };
              });
              break;
            case "BankDetails":
              array.push({
                PayTo: "",
                Bank: "",
                Branch: "",
                AccountNo: "",
                IFSCCode: "",
                DefaultBank: 1,
              });
              setErrors((prevErrors) => {
                let errArray = prevErrors?.BankDetails || [];
                errArray.push({
                  IFSCCode: { status: false, message: "" },
                  AccountNo: { status: false, message: "" },
                });
                return { ...prevErrors, BankDetails: errArray };
              });
              break;
            case "Identities":
              array.push({
                Type: "",
                Name: "",
                Number: "",
                Country: "",
                issueDate: "",
                expiryDate: "",
              });
              setErrors((prevErrors) => {
                let errArray = prevErrors?.Identities || [];
                errArray.push({
                  Type: { status: false, message: "" },
                  Name: { status: false, message: "" },
                  Number: { status: false, message: "" },
                  Country: { status: false, message: "" },
                });
                return { ...prevErrors, Identities: errArray };
              });
              break;
          }
          break;
        case "checkbox":
          switch (module) {
            case "BankDetails":
              if (value.target.checked) {
                for (let i = 0; i < array?.length; i++) {
                  array[i].DefaultBank = 1;
                }
                array[index][name] = value.target.checked;
              }
              break;
          }
          break;
      }
      return { ...prev, [module]: array };
    });
  };
  /* Handle Change with index and module end*/
  /* Handle file */
  const handleFile = (files) => {
    if (!files || files.length === 0) {
      toast.error("File size should not exceed 5MB.");
      return;
    }

    const maxSize = 5 * 1024 * 1024;
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ];

    let array = [...(formData.employeeAttachments || [])];
    let array1 = [...(formData.files || [])];
    let hasOversized = false;
    let hasInvalidType = false;

    Array.from(files).forEach((file) => {
      if (file.size > maxSize) {
        hasOversized = true;
        return;
      }
      if (!allowedTypes.includes(file.type)) {
        hasInvalidType = true;
        return;
      }
      array.push({
        file: file,
        FileName: file?.name,
        FileSize: (file.size / (1024 * 1024)).toFixed(2),
      });
      array1.push(file);
    });

    if (hasOversized) {
      toast.error("File size should not exceed 5MB.");
    }
    if (hasInvalidType) {
      toast.error("Only JPG, PNG and PDF files are allowed.");
    }

    setFormData({ ...formData, employeeAttachments: array, files: array1 });
    setErrors({ ...errors, employeeAttachments: [] });
  };
  /* Handle file ends*/
  /* Handle Profile pic */
  const handleProfilePic = (pic) => {
    setFormData({ ...formData, ProfilePic: pic });
    setProfilePicError("");
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   let isInvalid = false;
  //   let obj = {};

  //   for (let row of EmployeeSchema) {
  //     let temp = validate(formData[row.name], row.rule, row.type, row.name);
  //     obj[row.name] = temp;
  //     if (temp.status) {
  //       isInvalid = true;
  //     }
  //   }

  //   setErrors(obj);
  //   setSubmit(true);

  //   if (!formData.ProfilePic) {
  //     setProfilePicError("Profile picture is required.");
  //     toast.error("Profile picture is required.");
  //     setSubmit(false);
  //     return;
  //   }

  //   if (formData.ProfilePic.size / 1024 / 1024 > 1) {
  //     toast.error("Profile picture must be less than 1 MB.");
  //     setSubmit(false);
  //     return;
  //   }

  //   if (isInvalid) {
  //     setTimeout(() => {
  //       setSubmit(false);
  //     }, 4000);
  //     return false;
  //   } else {
  //     try {
  //       const pdf = new jsPDF({
  //         orientation: "portrait",
  //         unit: "mm",
  //         format: "a4",
  //         compress: true,
  //       });

  //       const modalContent = modalRef.current;
  //       if (!modalContent) {
  //         throw new Error("Modal content not found");
  //       }

  //       const canvas = await html2canvas(modalContent, {
  //         scale: 1,
  //         useCORS: true,
  //       });
  //       const imgData = canvas.toDataURL("image/jpeg", 1.0);

  //       pdf.addImage(imgData, "JPEG", 10, 10, 180, 0);

  //       const pdfArrayBuffer = pdf.output("arraybuffer");
  //       const pdfBlob = new Blob([pdfArrayBuffer], { type: "application/pdf" });
  //       const pdfFile = new File(
  //         [pdfBlob],
  //         formData?.FirstName + formData?.LastName + ".pdf",
  //         { type: "application/pdf" }
  //       );

  //       const payload = {
  //         ...formData,
  //         pdf: pdfFile,
  //       };

  //       let response = await PostFormServiceCaller(
  //         API_URL + "add-candidate-in-line-up",
  //         payload,
  //         "post"
  //       );

  //       toast.success(response.data.message);
  //       setSubmit(false);
  //       navigate("/details-submitted");

  //       if (response?.status === 200) {
  //         setShow(false);
  //       }
  //     } catch (error) {
  //       console.error("Error generating PDF:", error);
  //       toast.error("Failed to generate PDF.");
  //       setSubmit(false);
  //     }
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmit(true); // Show loader

    let pdfFile;

    try {
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        compress: true,
      });

      const modalContent = modalRef.current;
      if (!modalContent) {
        throw new Error("Modal content not found");
      }

      const canvas = await html2canvas(modalContent, {
        scale: 1,
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      pdf.addImage(imgData, "JPEG", 10, 10, 180, 0);

      const pdfArrayBuffer = pdf.output("arraybuffer");
      const pdfBlob = new Blob([pdfArrayBuffer], { type: "application/pdf" });
      pdfFile = new File(
        [pdfBlob],
        formData?.FirstName + formData?.LastName + ".pdf",
        { type: "application/pdf" }
      );
    } catch (error) {
      // Failure while building the PDF client-side (html2canvas/jsPDF/DOM)
      console.error("[CandidateDetails] PDF generation failed", {
        candidate_id,
        message: error?.message,
        stack: error?.stack,
      });
      toast.error(`Failed to generate PDF: ${error?.message || "Unknown error"}`);
      setSubmit(false);
      return;
    }

    try {
      const payload = {
        ...formData,
        TADocumentVerify: 0,
        pdf: pdfFile,
      };

      const appendObjectToFormData = (formDataObj, data, parentKey = "") => {
        if (data === null || data === undefined) return;
        if (typeof data !== "object" || data instanceof File || data instanceof Blob) {
          formDataObj.append(parentKey, data);
        } else {
          Object.keys(data).forEach((key) => {
            const propName = parentKey ? `${parentKey}[${key}]` : key;
            appendObjectToFormData(formDataObj, data[key], propName);
          });
        }
      };

      const formDataToSend = new FormData();
      appendObjectToFormData(formDataToSend, payload);

      let response = await PostFormServiceCaller(
        API_URL + "add-candidate-in-line-up",
        formDataToSend,
        "post"
      );

      if (response?.data?.status === "failed" || response?.data?.status === false) {
        toast.error(response?.data?.message || "Submission failed. Please check form details.");
        setSubmit(false);
        return;
      }

      toast.success(response?.data?.message || "Thank you, details added successfully.");
      clearDraft();
      setSubmit(false);
      setShow(false);
      navigate("/details-submitted");
    } catch (error) {
      // Failure while submitting the form/PDF to the backend
      console.error("[CandidateDetails] add-candidate-in-line-up failed", {
        candidate_id,
        status: error?.response?.status,
        responseData: error?.response?.data,
        message: error?.message,
      });

      const responseData = error?.response?.data;
      if (responseData?.errors && typeof responseData.errors === "object") {
        const errorMessages = Object.values(responseData.errors).flat();
        if (errorMessages.length > 0) {
          errorMessages.forEach((msg) => {
            if (msg && typeof msg === "string") toast.error(msg);
          });
        }
      } else {
        const backendMessage =
          responseData?.message || error?.message || "Submission failed. Please verify your details.";
        toast.error(`Submission error: ${backendMessage}`);
      }
      setSubmit(false);
    }
  };
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setAcknowledge(false);
    setShow(false);
  };

  /* Handle Submit End*/
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid">
          <h5 className="text-center mb-2 mt-2">
            Welcome to <strong>Nice Software Solutions</strong>
          </h5>
          <form id="formOne" className="rounded mt-4 bg-white">
            <div className="container-fluid">
              {/* tab section start */}
              <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    style={{ color: "#2F2E4B" }}
                    id="general-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#general"
                    type="button"
                    role="tab"
                    aria-controls="general"
                    aria-selected="true"
                  >
                    General Details
                    <span className="text-danger">
                      {formData.job_title?.label?.trim() &&
                        `: ${formData.job_title.label}`}
                    </span>
                    {tabErrorCounts["general-tab"] > 0 && (
                      <span className="badge rounded-pill bg-danger ms-1" style={{ fontSize: "11px" }}>
                        {tabErrorCounts["general-tab"]}
                      </span>
                    )}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="Contact-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#Contact"
                    type="button"
                    role="tab"
                    aria-controls="Contact"
                    aria-selected="false"
                  >
                    Contact Details
                    {tabErrorCounts["Contact-tab"] > 0 && (
                      <span className="badge rounded-pill bg-danger ms-1" style={{ fontSize: "11px" }}>
                        {tabErrorCounts["Contact-tab"]}
                      </span>
                    )}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="Qualification-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#Qualification"
                    type="button"
                    role="tab"
                    aria-controls="Qualification"
                    aria-selected="false"
                  >
                    Qualification
                    {tabErrorCounts["Qualification-tab"] > 0 && (
                      <span className="badge rounded-pill bg-danger ms-1" style={{ fontSize: "11px" }}>
                        {tabErrorCounts["Qualification-tab"]}
                      </span>
                    )}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="Bank-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#Bank"
                    type="button"
                    role="tab"
                    aria-controls="Bank"
                    aria-selected="false"
                  >
                    Bank Details
                    {tabErrorCounts["Bank-tab"] > 0 && (
                      <span className="badge rounded-pill bg-danger ms-1" style={{ fontSize: "11px" }}>
                        {tabErrorCounts["Bank-tab"]}
                      </span>
                    )}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="attachment-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#attachment"
                    type="button"
                    role="tab"
                    aria-controls="attachment"
                    aria-selected="false"
                  >
                    Attachments
                    {tabErrorCounts["attachment-tab"] > 0 && (
                      <span className="badge rounded-pill bg-danger ms-1" style={{ fontSize: "11px" }}>
                        {tabErrorCounts["attachment-tab"]}
                      </span>
                    )}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="identities-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#identities"
                    type="button"
                    role="tab"
                    aria-controls="identities"
                    aria-selected="false"
                  >
                    Identity
                    {tabErrorCounts["identities-tab"] > 0 && (
                      <span className="badge rounded-pill bg-danger ms-1" style={{ fontSize: "11px" }}>
                        {tabErrorCounts["identities-tab"]}
                      </span>
                    )}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="employment-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#employment"
                    type="button"
                    role="tab"
                    aria-controls="employment"
                    aria-selected="false"
                  >
                    Employment Details
                    {tabErrorCounts["employment-tab"] > 0 && (
                      <span className="badge rounded-pill bg-danger ms-1" style={{ fontSize: "11px" }}>
                        {tabErrorCounts["employment-tab"]}
                      </span>
                    )}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="additional-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#additional"
                    type="button"
                    role="tab"
                    aria-controls="additional"
                    aria-selected="false"
                  >
                    Additional
                    <span className="text-danger">
                      {formData.job_title?.label?.trim() &&
                        `: ${formData.job_title.label}`}
                    </span>
                    {tabErrorCounts["additional-tab"] > 0 && (
                      <span className="badge rounded-pill bg-danger ms-1" style={{ fontSize: "11px" }}>
                        {tabErrorCounts["additional-tab"]}
                      </span>
                    )}
                  </button>
                </li>
              </ul>

              {/* tab body section start */}
              <div className="tab-content p-2" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="general"
                  role="tabpanel"
                  aria-labelledby="general-tab"
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-10">
                        <div className="row">
                          <div className="col-sm-3">
                            <div className="">
                              <label className="form-label">
                                Title <span className="required">*</span>
                              </label>
                              <Select
                                name="Title"
                                options={[
                                  { label: "Select...", value: "" },
                                  ...title,
                                ]}
                                value={formData.Title}
                                onChange={(selected) =>
                                  handleChange(selected, "Title", "dropdown", [
                                    "required",
                                  ])
                                }
                              ></Select>
                              {errors?.Title && (
                                <span class="error">
                                  {errors?.Title?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label htmlFor="FirstName" className="form-label">
                                First Name
                                <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                placeholder="First Name"
                                className="form-control"
                                id="FirstName"
                                name="FirstName"
                                onChange={(e) =>
                                  handleChange(e, "FirstName", "input", [
                                    "required",
                                  ])
                                }
                                value={formData.FirstName}
                                onBlur={(e) =>
                                  handleChange(e, "FirstName", "input", [
                                    "required",
                                    "alpha",
                                  ])
                                }
                              />
                              {errors?.FirstName?.status && (
                                <span class="error">
                                  {errors?.FirstName?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label
                                htmlFor="MiddleName"
                                className="form-label"
                              >
                                Middle Name
                              </label>
                              <input
                                type="text"
                                placeholder="Middle Name"
                                className="form-control"
                                id="MiddleName"
                                name="MiddleName"
                                onChange={(e) =>
                                  handleChange(e, "MiddleName", "input", [
                                    "alpha",
                                  ])
                                }
                                value={formData.MiddleName}
                              />
                              {errors?.MiddleName?.status && (
                                <span class="error">
                                  {errors?.MiddleName?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label htmlFor="LastName" className="form-label">
                                Last Name
                                <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                placeholder="Last Name"
                                className="form-control"
                                id="LastName"
                                name="LastName"
                                onChange={(e) =>
                                  handleChange(e, "LastName", "input", [
                                    "required",
                                    "alpha",
                                  ])
                                }
                                onBlur={(e) =>
                                  handleChange(e, "LastName", "input", [
                                    "required",
                                    "alpha",
                                  ])
                                }
                                value={formData.LastName}
                              />
                              {errors?.LastName?.status && (
                                <span class="error">
                                  {errors?.LastName?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label
                                htmlFor="FatherName"
                                className="form-label"
                              >
                                Father Name
                              </label>
                              <input
                                type="text"
                                placeholder="Father's Name"
                                className="form-control"
                                id="FatherName"
                                name="FatherName"
                                onChange={(e) =>
                                  handleChange(e, "FatherName", "input")
                                }
                                value={formData.FatherName}
                              />
                            </div>
                          </div>
                          {/* <div className="col-sm-3">
                            <div className="form-group">
                              <label htmlFor="FatherDOB" className="form-label">
                                Father's DOB
                              </label>
                              <CustomDatePicker
                                name="FatherDOB"
                                id="FatherDOB"
                                placeholderText="DD-MMM-YYYY"
                                value={formData.FatherDOB}
                                handleChange={handleChange}
                              ></CustomDatePicker>
                            </div>
                          </div> */}
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label
                                htmlFor="MotherName"
                                className="form-label"
                              >
                                Mother Name
                              </label>
                              <input
                                type="text"
                                placeholder="Mother's Name"
                                className="form-control"
                                id="MotherName"
                                name="MotherName"
                                onChange={(e) =>
                                  handleChange(e, "MotherName", "input")
                                }
                                value={formData.MotherName}
                              />
                            </div>
                          </div>
                          {/* <div className="col-sm-3">
                            <div className="form-group">
                              <label htmlFor="MotherDOB" className="form-label">
                                Mother's DOB
                              </label>
                              <CustomDatePicker
                                handleChange={handleChange}
                                name="MotherDOB"
                                id="MotherDOB"
                                placeholderText="DD-MMM-YYYY"
                                value={formData.MotherDOB}
                              ></CustomDatePicker>
                            </div>
                          </div> */}
                          <div className="col-sm-3">
                            <div className="">
                              <label className="form-label">
                                Gender <span className="required">*</span>
                              </label>
                              <Select
                                name="Gender"
                                value={formData.Gender}
                                onChange={(e) =>
                                  handleChange(e, "Gender", "dropdown", [
                                    "required",
                                  ])
                                }
                                options={[
                                  { label: "Select...", value: "" },
                                  ...gendetType,
                                ]}
                              ></Select>
                              {errors?.Gender?.status && (
                                <span class="error">
                                  {errors?.Gender?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <label className="form-label">
                              Date Of Birth<span className="required">*</span>
                            </label>
                            <CustomDatePicker
                              name="DateOfBirth"
                              id="DateOfBirth"
                              placeholderText="DD-MMM-YYYY"
                              value={formData.DateOfBirth}
                              handleChange={handleChange}
                              maxDate={subYears(new Date(), 18)}
                              required={true}
                            ></CustomDatePicker>
                            {errors?.DateOfBirth?.status && (
                              <span class="error">
                                {errors?.DateOfBirth?.message}
                              </span>
                            )}
                          </div>
                          {/* <div className="col-sm-2">
                            <label htmlFor="IsInActive" className="form-label">
                              Active
                            </label>
                            <div className="me-2 mt-0">
                              <div className="d-flex">
                                <div className="form-check me-2" key={"Yes"}>
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name={`rating_1`}
                                    id={`rating_1_yes`}
                                    value={"Yes"}
                                    checked={
                                      formData.Active == 0 ? "checked" : false
                                    }
                                    onClick={(e) =>
                                      handleChange(e, "Active", "radio")
                                    }
                                  />
                                  <label className="form-check-label">
                                    Yes
                                  </label>
                                </div>
                                <div className="form-check me-2" key={"No"}>
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name={`rating_1`}
                                    id={`rating_1_No`}
                                    value={"No"}
                                    checked={
                                      formData.Active == 1 ? "checked" : false
                                    }
                                    onClick={(e) =>
                                      handleChange(e, "Active", "radio")
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`rating_1_No`}
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                      <div className="col-sm-2 text-center">
                        <div className="mb-2">
                          {profilePicError && (
                            <p className="text-danger m-0">{profilePicError}</p>
                          )}
                        </div>
                        <ProfileInput
                          image={
                            formData?.OldProfilePic
                              ? formData?.OldProfilePic
                              : profilePicPreview
                              ? profilePicPreview
                              : false
                          }
                          handleProfilePic={handleProfilePic}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* contact detail */}
                <div
                  className="tab-pane fade show"
                  id="Contact"
                  role="tabpanel"
                  aria-labelledby="Contact-tab"
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="form-label">
                            Contact No.<span className="required">*</span>
                          </label>
                          <input
                            // onlyCountries={['in', 'ae']}
                            // localization="in"
                            // defaultCountry="in"
                            // prefix=""
                            className="form-control"
                            value={formData.MobileNo1}
                            name="MobileNo1"
                            onChange={(e) =>
                              handleChange(e, "MobileNo1", "mobile", [
                                "required",
                              ])
                            }
                            id="MobileNo1"
                          />

                          {errors?.MobileNo1?.status && (
                            <span className="error">
                              {errors?.MobileNo1?.message}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="form-label">
                              Whatapp No.
                          </label>
                          <input
                            defaultCountry="in"
                            className="form-control"
                            value={formData?.MobileNo2 || ""}
                            name="MobileNo2"
                            onChange={(e) =>
                              handleChange(e, "MobileNo2", "mobile")
                            }
                            id="MobileNo2"
                          />
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="form-label">
                            Emergency Phone No.<span className="required">*</span>
                          </label>
                          <input
                            // defaultCountry="in"
                            // onlyCountries={['in', 'ae']}
                            // localization="in"
                            // prefix=""
                            className="form-control"
                            value={formData?.EmergencyPhoneNo || ""}
                            // disableFormatting={true}
                            name="EmergencyPhoneNo"
                            onChange={(e) =>
                              handleChange(e, "EmergencyPhoneNo", "mobile", ["required"])
                            }
                            id="EmergencyPhoneNo"
                          />
                           {errors?.EmergencyPhoneNo?.status && (
                            <span className="error">
                              {errors?.EmergencyPhoneNo?.message}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="form-label">
                            Emergency Contact Name<span className="required">*</span>
                          </label>
                          <input
                            placeholder="Emergency Contact Name"
                            className="form-control"
                            type="text"
                            name="EmergencyContactName"
                            value={formData.EmergencyContactName}
                            onChange={(e) =>
                              handleChange(e, "EmergencyContactName", "input-submit", ["required"])
                            }
                          />
                          {errors?.EmergencyContactName?.status && (
                            <span className="error">
                              {errors?.EmergencyContactName?.message}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="form-label">Emergency Contact Relation<span className="required">*</span></label>
                          <input
                            placeholder="Emergency Contact Relation"
                            className="form-control"
                            type="text"
                            name="EmergencyContactRelation"
                            value={formData.EmergencyContactRelation}
                            onChange={(e) =>
                              handleChange(
                                e,
                                "EmergencyContactRelation",
                                "input-submit", ["required"]
                              )
                            }
                          />
                          {errors?.EmergencyContactRelation?.status && (
                            <span className="error">
                              {errors?.EmergencyContactRelation?.message}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="form-label">Personal Email</label>
                          <input
                            placeholder="Personal Email"
                            className="form-control"
                            type="text"
                            name="PersonalEmail"
                            value={formData.PersonalEmail}
                            onChange={(e) =>
                              handleChange(e, "PersonalEmail", "input")
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="form-label">
                            WhatsApp No.<span className="required">*</span>
                          </label>
                          <input
                            // onlyCountries={['in', 'ae']}
                            // localization="in"
                            // defaultCountry="in"
                            // prefix=""
                            className="form-control"
                            value={formData.WhatappNo}
                            name="WhatappNo"
                            onChange={(e) =>
                              handleChange(e, "WhatappNo", "mobile", [
                                "required",
                              ])
                            }
                            id="WhatappNo"
                          />

                          {errors?.MobileNo1?.status && (
                            <span className="error">
                              {errors?.MobileNo1?.message}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6 mt-4">
                        <p>
                          <strong>Correspondence Address</strong>
                        </p>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="">
                              <label className="form-label">Address Type</label>
                              <Select
                                isDisabled={true}
                                name="CorrepondenceAddressType"
                                options={addressType}
                                value={formData.CorrepondenceAddressType}
                              ></Select>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">
                                Address <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                className={
                                  errors?.CorrespondenceAddress?.status
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                name="CorrespondenceAddress"
                                value={formData.CorrespondenceAddress}
                                onChange={(e) =>
                                  handleChange(
                                    e,
                                    "CorrespondenceAddress",
                                    "input",
                                    ["required"]
                                  )
                                }
                                onBlur={(e) => {
                                  updateAddress(
                                    e,
                                    "CorrespondenceAddress",
                                    "Address"
                                  );
                                  handleChange(
                                    e,
                                    "CorrespondenceAddress",
                                    "input",
                                    ["required"]
                                  );
                                }}
                              ></input>
                              {errors?.CorrespondenceAddress?.status && (
                                <span className="error">
                                  {errors?.CorrespondenceAddress?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">Country<span className="required">*</span></label>
                              <Select
                                name="CorrespondenceCountry"
                                className={
                                  errors?.CorrespondenceCountry?.status
                                    ? "is-invalid"
                                    : ""
                                }
                                options={[
                                  { value: "", label: "Select..." },
                                  ...countryList,
                                ]}
                                value={countryList?.find(
                                  (o) =>
                                    o.value ===
                                    Number(formData.CorrespondenceCountryID)
                                )}
                                onChange={(e) => {
                                  handleChange(
                                    e,
                                    "CorrespondenceCountry",
                                    "country",
                                    ["required"]
                                  );
                                }}
                              />
                              {errors?.CorrespondenceCountry?.status && (
                                <span className="error">
                                  {errors?.CorrespondenceCountry?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">
                                State<span className="required">*</span>
                              </label>
                              <Select
                                className={
                                  errors?.CorrespondenceState?.status
                                    ? "is-invalid"
                                    : ""
                                }
                                name="CorrespondenceState"
                                options={[
                                  { value: "", label: "Select..." },
                                  ...stateList,
                                ]}
                                value={stateList?.find(
                                  (o) =>
                                    o.value ===
                                    Number(formData.CorrespondenceStateID)
                                )}
                                onChange={(e) => {
                                  handleChange(
                                    e,
                                    "CorrespondenceState",
                                    "state",
                                    ["required"]
                                  );
                                }}
                              ></Select>
                              {errors?.CorrespondenceState?.status && (
                                <span className="error">
                                  {errors?.CorrespondenceState?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <label className="form-label">
                              City<span className="required">*</span>
                            </label>
                            <Select
                              className={
                                errors?.CorrespondenceCity?.status
                                  ? "is-invalid"
                                  : ""
                              }
                              name="CorrespondenceCity"
                              options={[
                                { value: "", label: "Select..." },
                                ...cityList,
                              ]}
                              value={cityList?.find(
                                (o) =>
                                  o.value ===
                                  Number(formData.CorrespondenceCityID)
                              )}
                              onChange={(e) => {
                                handleChange(e, "CorrespondenceCity", "city", [
                                  "required",
                                ]);
                              }}
                            ></Select>
                            {errors?.CorrespondenceCity?.status && (
                              <span className="error">
                                {errors?.CorrespondenceCity?.message}
                              </span>
                            )}
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">Zip Code</label>
                              <input
                                type="text"
                                className="form-control"
                                name="CorrespondenceZip"
                                value={formData.CorrespondenceZip}
                                onChange={(e) =>
                                  handleChange(e, "CorrespondenceZip", "input")
                                }
                                onBlur={(e) =>
                                  updateAddress(
                                    e,
                                    "CorrespondenceZip",
                                    "Zipcode"
                                  )
                                }
                              ></input>
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label className="form-label">
                                Print Address
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="CorrespondenceAddressPrint"
                                value={formData.CorrespondenceAddressPrint}
                                onChange={(e) => {
                                  handleChange(
                                    e,
                                    "CorrespondenceAddressPrint",
                                    "input"
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 mt-4">
                    <div className="d-flex align-items-center mb-2 gap-2">
  <p className="m-0">
    <strong>Permanent Address</strong>
  </p>
 ( <div className="form-check m-0">
    <input
      className="form-check-input"
      type="checkbox"
      name="IsCopyAddress"
      value="1"
      id="IsCopyAddress"
      checked={formData.IsCopyAddress == 1}
      onClick={(e) => handleChange(e, "IsCopyAddress", "checkbox-copy")}
    />
    <label className="form-check-label" htmlFor="IsCopyAddress">
      Is Same as Correspondence Address?
    </label>
  </div>)
</div>

                        <div className="row">
                       
                          <div className="col-sm-6">
                            <div className="">
                              <label className="form-label">Address Type</label>
                              <Select
                                isDisabled={true}
                                name="PermanentAddressType"
                                options={addressType}
                                value={formData.PermanentAddressType}
                              ></Select>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">
                                Address <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                className={
                                  errors?.PermanentAddress?.status
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                name="PermanentAddress"
                                value={formData.PermanentAddress}
                                onChange={(e) =>
                                  handleChange(e, "PermanentAddress", "input", [
                                    "required",
                                  ])
                                }
                                onBlur={(e) => {
                                  updateAddress(
                                    e,
                                    "PermanentAddress",
                                    "Address"
                                  );
                                  handleChange(e, "PermanentAddress", "input", [
                                    "required",
                                  ]);
                                }}
                              ></input>
                              {errors?.PermanentAddress?.status && (
                                <span className="error">
                                  {errors?.PermanentAddress?.message}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">Country<span className="required">*</span></label>
                              {/* <input
                                type="text"
                                className="form-control"
                                name="PermanentCountry"
                                value={formData.PermanentCountry}
                                onChange={(e) =>
                                  handleChange(e, "PermanentCountry", "input")
                                }
                              ></input> */}
                              <Select
                                name="PermanentCountry"
                                className={
                                  errors?.PermanentCountry?.status
                                    ? "is-invalid"
                                    : ""
                                }
                                options={[
                                  { value: "", label: "Select..." },
                                  ...countryList,
                                ]}
                                value={countryList?.find(
                                  (o) =>
                                    o.value ===
                                    Number(formData.PermanentCountryID)
                                )}
                                onChange={(e) => {
                                  handleChange(
                                    e,
                                    "PermanentCountry",
                                    "country",
                                    ["required"]
                                  );
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">State<span className="required">*</span></label>
                              <Select
                                name="PermanentState"
                                className={
                                  errors?.PermanentState?.status
                                    ? "is-invalid"
                                    : ""
                                }
                                options={[
                                  { value: "", label: "Select..." },
                                  ...stateList,
                                ]}
                                value={stateList?.find(
                                  (o) =>
                                    o.value ===
                                    Number(formData.PermanentStateID)
                                )}
                                onChange={(e) => {
                                  handleChange(e, "PermanentState", "state", [
                                    "required",
                                  ]);
                                }}
                              />
                              {/* <input
                                type="text"
                                className="form-control"
                                name="PermanentState"
                                value={formData.PermanentState}
                                onChange={(e) =>
                                  handleChange(e, "PermanentState", "input")
                                }
                              ></input> */}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <label className="form-label">
                              City<span className="required">*</span>
                            </label>
                            <Select
                              name="PermanentCity"
                              className={
                                errors?.PermanentCity?.status
                                  ? "is-invalid"
                                  : ""
                              }
                              options={[
                                { value: "", label: "Select..." },
                                ...cityList,
                              ]}
                              value={cityList?.find(
                                (o) =>
                                  o.value === Number(formData.PermanentCityID)
                              )}
                              onChange={(e) => {
                                handleChange(e, "PermanentCity", "city", [
                                  "required",
                                ]);
                              }}
                            />
                            {errors?.PermanentCity?.status && (
                              <span className="error">
                                {errors?.PermanentCity?.message}
                              </span>
                            )}
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label className="form-label">Zip Code</label>
                              <input
                                type="text"
                                className="form-control"
                                name="PermanentZip"
                                value={formData.PermanentZip}
                                onChange={(e) =>
                                  handleChange(e, "PermanentZip", "input")
                                }
                                onBlur={(e) =>
                                  updateAddress(e, "PermanentZip", "Zipcode")
                                }
                              ></input>
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label className="form-label">
                                Print Address
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="PermanentAddressPrint"
                                value={formData.PermanentAddressPrint}
                                onChange={(e) => {
                                  handleChange(
                                    e,
                                    "PermanentAddressPrint",
                                    "input"
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Qualification */}
                <div
                  className="tab-pane fade show"
                  id="Qualification"
                  role="tabpanel"
                  aria-labelledby="Qualification-tab"
                >
                  <div className="Container-fluid">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="row">
                          <p>
                            <button
                              className="custom-btn pull-right"
                              onClick={(e) =>
                                handleChangeWithIndex(
                                  e,
                                  "addRow",
                                  "Qualification",
                                  "",
                                  ""
                                )
                              }
                            >
                              <i className="bi bi-plus-circle"></i>
                            </button>
                          </p>
                          <div className="table-responsive poc-head rounded">
                            <table
                              id="poctable_head"
                              className="table table-bordered"
                            >
                              <thead id="thcolor" className="text-center">
                                <tr>
                                  <th style={{ width: "15%" }}>
                                    Qualification Type <span className="text-danger">*</span>
                                  </th>
                                  {/* <th style={{ width: "10%" }}>
                                    Qualification <span className="text-danger">*</span>
                                  </th> */}
                                  <th style={{ width: "10%" }}>Stream <span className="text-danger">*</span></th>
                                  <th style={{ width: "15%" }}>University <span className="text-danger">*</span></th>
                                  <th style={{ width: "17%" }}>Institute <span className="text-danger">*</span></th>
                                  <th style={{ width: "13%" }}>Percentage / CGPA <span className="text-danger">*</span></th>
                                  <th style={{ width: "10%" }}>
                                    Year Of Passing <span className="text-danger">*</span>
                                  </th>
                                  <th style={{ width: "6%" }}>File <span className="text-danger">*</span></th>
                                  <th style={{ width: "4%" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {errors?.Qualification?.status && (
                                  <tr>
                                    <td colSpan={6} className="text-center">
                                      <span className="error">
                                        {errors?.Qualification?.message}
                                      </span>
                                    </td>
                                  </tr>
                                )}
                                {formData.Qualification &&
                                  formData.Qualification.map &&
                                  formData.Qualification.map((line, index) => (
                                    <tr>
                                      <td>
                                        <input
                                          type="text"
                                          className={
                                            errors?.Qualification?.[index]?.Type
                                              ?.status
                                              ? "is-invalid form-control"
                                              : "form-control"
                                          }
                                          placeholder="Qualification Type"
                                          name="Type"
                                          value={
                                            formData.Qualification[index].Type
                                          }
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Qualification",
                                              index,
                                              "Type",
                                              ["required"]
                                            )
                                          }
                                          onBlur={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Qualification",
                                              index,
                                              "Type",
                                              ["required"]
                                            )
                                          }
                                          readOnly={formData.Qualification[index].isDefault}
                                          style={{ backgroundColor: formData.Qualification[index].isDefault ? "#e9ecef" : "" }}
                                        />
                                        {errors?.Qualification?.[index]?.Type
                                          ?.status && (
                                            <span className="error">
                                              {
                                                errors?.Qualification?.[index]
                                                  ?.Type?.message
                                              }
                                            </span>
                                          )}
                                      </td>
                                      {/* <td>
                                        <input
                                          className={
                                            errors?.Qualification?.[index]
                                              ?.Qualification?.status
                                              ? "is-invalid form-control"
                                              : "form-control"
                                          }
                                          placeholder="Qualification"
                                          name="Qualification"
                                          value={
                                            formData.Qualification[index]
                                              .Qualification
                                          }
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Qualification",
                                              index,
                                              "Qualification",
                                              ["required"]
                                            )
                                          }
                                          onBlur={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Qualification",
                                              index,
                                              "Qualification",
                                              ["required"]
                                            )
                                          }
                                        />
                                        {errors?.Qualification?.[index]
                                          ?.Qualification?.status && (
                                            <span className="error">
                                              {
                                                errors?.Qualification?.[index]
                                                  ?.Qualification?.message
                                              }
                                            </span>
                                          )}
                                      </td> */}
                                      <td>
                                        <input
                                          className="form-control"
                                          placeholder="Stream"
                                          name="Stream"
                                          value={
                                            formData.Qualification[index].Stream
                                          }
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Qualification",
                                              index,
                                              "Stream"
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          className={
                                            errors?.Qualification?.[index]
                                              ?.University?.status
                                              ? "is-invalid form-control"
                                              : "form-control"
                                          }
                                          placeholder="University"
                                          name="University"
                                          value={
                                            formData.Qualification[index]
                                              .University
                                          }
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Qualification",
                                              index,
                                              "University",
                                              ["required"]
                                            )
                                          }
                                          onBlur={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Qualification",
                                              index,
                                              "University",
                                              ["required"]
                                            )
                                          }
                                        />
                                        {errors?.Qualification?.[index]
                                          ?.University?.status && (
                                            <span className="error">
                                              {
                                                errors?.Qualification?.[index]
                                                  ?.University?.message
                                              }
                                            </span>
                                          )}
                                      </td>
                                      <td>
                                        <input
                                          className="form-control"
                                          placeholder="Institute"
                                          name="Institute"
                                          value={
                                            formData.Qualification[index]
                                              .Institute
                                          }
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Qualification",
                                              index,
                                              "Institute"
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          className="form-control"
                                          placeholder="Percentage / CGPA"
                                          name="Percentage"
                                          value={
                                            formData.Qualification[index]
                                              .Percentage
                                          }
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Qualification",
                                              index,
                                              "Percentage"
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          className="form-control text-end"
                                          placeholder="YearOfPassing"
                                          name="YearOfPassing"
                                          value={
                                            formData.Qualification[index]
                                              .YearOfPassing
                                          }
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Qualification",
                                              index,
                                              "YearOfPassing"
                                            )
                                          }
                                        />
                                      </td>
                                      <td className="text-center">
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "10px",
                                            marginTop: "10px",
                                          }}
                                        >
                                          {/* Upload Icon */}
                                          <label
                                            htmlFor={`qualification-file-${index}`}
                                            title="Upload File"
                                            style={{
                                              cursor: "pointer",
                                              margin: 0,
                                            }}
                                          >
                                            <i
                                              className="fa fa-cloud-upload"
                                              style={{
                                                fontSize: "14px",
                                                color: "#27568B",
                                              }}
                                            />
                                          </label>
                                          <input
                                            id={`qualification-file-${index}`}
                                            type="file"
                                            accept=".jpg,.jpeg,.png,.pdf"
                                            onChange={(e) =>
                                              handleQualificationFileChange(e.target.files, index)
                                            }
                                            style={{ display: "none" }}
                                          />
                                          {/* View Icon */}
                                          {formData.Qualification[index]?.QualificationFile && (
                                            <a
                                              href={
                                                typeof formData.Qualification[index].QualificationFile === "string"
                                                  ? formData.Qualification[index].QualificationFile
                                                  : formData.Qualification[index].QualificationFilePreview
                                              }
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              title="View File"
                                            >
                                              <i
                                                className="fa fa-eye"
                                                style={{
                                                  fontSize: "14px",
                                                  color: "#27568B",
                                                  cursor: "pointer",
                                                }}
                                              />
                                            </a>
                                          )}
                                        </div>
                                      </td>
                                      <td className="text-center align-middle">
                                        <a
                                          onClick={(e) =>
                                            handleShowModal(
                                              e,
                                              "remove",
                                              "Qualification",
                                              index
                                            )
                                          }
                                          // onClick={(e) =>
                                          //   handleChangeWithIndex(
                                          //     e,
                                          //     "remove",
                                          //     "Qualification",
                                          //     index,
                                          //     ""
                                          //   )
                                          // }
                                          className="del_icon"
                                        >
                                          <i className="bi bi-trash"></i>
                                        </a>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                            <div className="attach_msg">
                              Note:
                              <ul>
                                <li>
                                  Please fill in a minimum of 3 education details, such as 10th, 12th, Graduation, or Postgraduate degree information.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Bank Details */}
                  <div
                    className="tab-pane fade show"
                    id="Bank"
                    role="tabpanel"
                    aria-labelledby="Bank-tab"
                  >
                    <div className="container-fluid mt-2">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="row">
                            {/* REMOVE THIS BUTTON - Delete or comment out the Add New Record button */}
                            {/* <p>
                              <button
                                className="custom-btn pull-right"
                                onClick={(e) =>
                                  handleAddLine(
                                    e,
                                    "employeebank",
                                    initialFormData?.employeebank,
                                    "PayTo"
                                  )
                                }
                              >
                                Add New Record
                              </button>
                            </p> */}
                            
                            <div className="table-responsive poc-head rounded">
                              <Table
                                id="poctable_head"
                                className="table table-bordered"
                              >
                                <thead id="thcolor" className="text-center">
                                  <tr>
                                    <th style={{ width: "15%" }}>Pay To</th>
                                    <th style={{ width: "15%" }}>
                                      Bank<span className="required">*</span>
                                    </th>
                                    <th style={{ width: "15%" }}>
                                      Branch
                                    </th>
                                    <th style={{ width: "15%" }}>
                                      Account No.<span className="required">*</span>
                                    </th>
                                    <th style={{ width: "15%" }}>
                                      IFSC Code<span className="required">*</span>
                                    </th>
                                    {/* <th
                                      style={{
                                        width: "5%",
                                        textAlign: "center",
                                      }}
                                    >
                                      Default
                                    </th> */}
                                    <th style={{ width: "5%" }}>Delete</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {formData.employeebank &&
                                    formData.employeebank.map &&
                                    formData.employeebank.map((line, index) => (
                                      <tr key={line.LineNo || index}>
                                        <td>
                                          <input
                                            type="text"
                                            placeholder="In case of contractor"
                                            className="form-control"
                                            name="PayTo"
                                            value={`${formData.FirstName || ""} ${formData.LastName || ""
                                              }`.trim()}
                                            onChange={(e) =>
                                              handleAllLineChange(
                                                e,
                                                index,
                                                "employeebank"
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <Select
                                            menuPlacement="top"
                                            styles={tableSelectStyle}
                                            menuPortalTarget={document.body}
                                            name="Bank"
                                            value={bankOptions?.find(
                                              (option) =>
                                                option.value ==
                                                formData?.employeebank[index]?.Bank
                                            )}
                                            options={[
                                              { value: "", label: "Select" },
                                              ...bankOptions,
                                            ]}
                                            onChange={(selectedOption, action) =>
                                              handleLineSelect(
                                                selectedOption,
                                                action.name,
                                                index,
                                                "employeebank"
                                              )
                                            }
                                          />
                                          {errors[
                                            `employeebank[${index}].Bank`
                                          ] && (
                                            <span className="error">
                                              {
                                                errors[
                                                `employeebank[${index}].Bank`
                                                ]
                                              }
                                            </span>
                                          )}
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            placeholder="Branch"
                                            className={`form-control ${errors?.[
                                              `employeebank[${index}].Branch`
                                            ]
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            name="Branch"
                                            value={
                                              formData.employeebank?.[index].Branch
                                            }
                                            onChange={(e) =>
                                              handleAllLineChange(
                                                e,
                                                index,
                                                "employeebank"
                                              )
                                            }
                                          />
                                          {errors[
                                            `employeebank[${index}].Branch`
                                          ] && (
                                            <span className="error">
                                              {
                                                errors[
                                                `employeebank[${index}].Branch`
                                                ]
                                              }
                                            </span>
                                          )}
                                        </td>
                                        <td>
                                          <input
                                            type="number"
                                            placeholder="Account No"
                                            className={`form-control text-end${errors?.[
                                              `employeebank[${index}].AccountNo`
                                            ]
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            name="AccountNo"
                                            value={
                                              formData.employeebank[index].AccountNo
                                            }
                                            onChange={(e) =>
                                              handleAllLineChange(
                                                e,
                                                index,
                                                "employeebank"
                                              )
                                            }
                                            onKeyDown={(e) => {
                                              if (
                                                ["e", "E", "+", "-", "."].includes(
                                                  e.key
                                                )
                                              ) {
                                                e.preventDefault();
                                              }
                                            }}
                                          />
                                          {errors[
                                            `employeebank[${index}].AccountNo`
                                          ] && (
                                            <span className="error">
                                              {
                                                errors[
                                                `employeebank[${index}].AccountNo`
                                                ]
                                              }
                                            </span>
                                          )}
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            placeholder="IFSC Code"
                                            className={`form-control text-end${errors?.[
                                              `employeebank[${index}].IFSCCode`
                                            ]
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            name="IFSCCode"
                                            value={
                                              formData.employeebank[index].IFSCCode
                                            }
                                            onChange={(e) =>
                                              handleAllLineChange(
                                                e,
                                                index,
                                                "employeebank"
                                              )
                                            }
                                          />
                                          {errors[
                                            `employeebank[${index}].IFSCCode`
                                          ] && (
                                            <span className="error">
                                              {
                                                errors[
                                                `employeebank[${index}].IFSCCode`
                                                ]
                                              }
                                            </span>
                                          )}
                                        </td>
                                        {/* <td className="text-center align-middle">
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value="1"
                                            name="DefaultBank"
                                            id="DefaultBank"
                                            checked={
                                              formData.employeebank[index]
                                                .DefaultBank == 1
                                            }
                                            onChange={(e) =>
                                              handleAllLineChange(
                                                e,
                                                index,
                                                "employeebank"
                                              )
                                            }
                                          />
                                        </td> */}
                                        <td className="text-center align-middle">
                                          <a
                                            onClick={(e) =>
                                              deleteLine(
                                                e,
                                                "employeebank",
                                                line.LineNo
                                              )
                                            }
                                            className=""
                                          >
                                            <i className="bi bi-trash"></i>
                                          </a>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                {/* Employee Attachments */}
                <div
                  className="tab-pane fade show"
                  id="attachment"
                  role="tabpanel"
                  aria-labelledby="attachment-tab"
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="row">
                          <p>
                            <span className="pull-right">
                              {" "}
                              Max 5 MB | Allowed: PDF, JPG, PNG &nbsp;
                              <FileUploader handleFile={handleFile} />
                            </span>
                          </p>
                          <div className="table-responsive poc-head rounded">
                            <table
                              id="poctable_head"
                              className="table table-bordered"
                            >
                              <thead id="thcolor" className="text-center">
                                <tr>
                                  <th style={{ width: "40%" }}>File Name</th>
                                  <th style={{ width: "40%" }}>File Size</th>
                                  <th style={{ width: "20%" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {errors?.employeeAttachments?.status && (
                                  <tr>
                                    <td className="text-center" colSpan={3}>
                                      <span className="error">
                                        {errors?.employeeAttachments?.message}
                                      </span>
                                    </td>
                                  </tr>
                                )}
                                {formData.employeeAttachments &&
                                  formData.employeeAttachments.map &&
                                  formData.employeeAttachments.map(
                                    (line, index) => (
                                      <tr>
                                        {/* <td
                                          onClick={() => openPdf(line.FilePath)}
                                          style={{
                                            cursor: "pointer",
                                            color: "blue",
                                          }}
                                        > */}
                                        <td>
                                          <a
                                            href={line.FilePath}
                                            target="_blank"
                                          >
                                            {line.FileName}
                                          </a>
                                          {/* {line.FileName} */}
                                        </td>
                                        <td>{line.FileSize} MB</td>
                                        <td className="text-center align-middle">
                                          <a
                                            onClick={(e) =>
                                              handleShowModal(
                                                e,
                                                "remove",
                                                "employeeAttachments",
                                                index,
                                                line
                                              )
                                            }
                                            // onClick={(e) =>
                                            //   handleChangeWithIndex(
                                            //     e,
                                            //     "remove",
                                            //     "employeeAttachments",
                                            //     index,
                                            //     ""
                                            //   )
                                            // }
                                            className="del_icon"
                                          >
                                            <i className="bi bi-trash"></i>
                                          </a>
                                        </td>
                                      </tr>
                                    )
                                  )}
                              </tbody>
                            </table>
                            <div className="attach_msg">
                              Note:
                              <ul>
                                <li>
                                  Please attach all relevant supporting documents.
                                </li>
                                <li>
                                  File Naming Format: YourName_FileName.extension (e.g., JohnDoe_Resume.pdf, JohnDoe_10thMarkSheet.pdf).
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Employee Identities */}
                <div
                  className="tab-pane fade show"
                  id="identities"
                  role="tabpanel"
                  aria-labelledby="identities-tab"
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="row">
                          <p>
                            <button
                              className="custom-btn pull-right"
                              onClick={(e) =>
                                handleChangeWithIndex(
                                  e,
                                  "addRow",
                                  "Identities",
                                  "",
                                  ""
                                )
                              }
                            >
                              <i className="bi bi-plus-circle"></i>
                            </button>
                          </p>
                          <div className="table-responsive poc-head rounded">
                            <table
                              id="poctable_head"
                              className="table table-bordered"
                            >
                              <thead id="thcolor" className="text-center">
                                <tr>
                                  <th style={{ width: "15%" }}>Identity <span className="text-danger">*</span></th>
                                  <th style={{ width: "25%" }}>
                                    Name On Identity <span className="text-danger">*</span>
                                  </th>
                                  <th style={{ width: "15%" }}>Identity No. <span className="text-danger">*</span></th>
                                  <th style={{ width: "15%" }}>
                                    Issuing Country <span className="text-danger">*</span>
                                  </th>
                                  <th style={{ width: "12%" }}>Issue Date</th>
                                  <th style={{ width: "12%" }}>Expiry Date</th>
                                  <th style={{ width: "8%" }}>File <span className="text-danger">*</span></th>
                                  <th style={{ width: "4%" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {errors?.Identities?.status && (
                                  <tr>
                                    <td colSpan={6} className="text-center">
                                      <span className="error">
                                        {errors?.Identities?.message}
                                      </span>
                                    </td>
                                  </tr>
                                )}
                                {formData.Identities &&
                                  formData.Identities.map &&
                                  formData.Identities.map((line, index) => (
                                    <tr>
                                      <td>
                                        <Select
                                          className={
                                            errors?.Identities?.[index]?.Type
                                              ?.status
                                              ? "is-invalid"
                                              : ""
                                          }
                                          name="Type"
                                          value={
                                            formData.Identities[index].Type
                                          }
                                          isDisabled={formData.Identities[index].isDefault}
                                          menuPortalTarget={document.body}
                                          styles={tableSelectStyle}
                                          menuPlacement="top"
                                          options={[
                                            { label: "Select...", value: "" },
                                            ...identityType,
                                          ]}
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "dropdown",
                                              "Identities",
                                              index,
                                              "Type",
                                              ["required"]
                                            )
                                          }
                                        ></Select>
                                        {errors?.Identities?.[index]?.Type
                                          ?.status && (
                                            <span className="error">
                                              {
                                                errors?.Identities?.[index]?.Type
                                                  ?.message
                                              }
                                            </span>
                                          )}
                                      </td>
                                      <td>
                                        <input
                                          className={
                                            errors?.Identities?.[index]?.Name
                                              ?.status
                                              ? "is-invalid form-control"
                                              : "form-control"
                                          }
                                          placeholder="Name as per identity"
                                          name="Name"
                                          value={
                                            formData.Identities[index].Name
                                          }
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Identities",
                                              index,
                                              "Name",
                                              ["required"]
                                            )
                                          }
                                          onBlur={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Identities",
                                              index,
                                              "Name",
                                              ["required"]
                                            )
                                          }
                                        />
                                        {errors?.Identities?.[index]?.Name
                                          ?.status && (
                                            <span className="error">
                                              {
                                                errors?.Identities?.[index]?.Name
                                                  ?.message
                                              }
                                            </span>
                                          )}
                                      </td>
                                      <td>
                                        <input
                                          className={
                                            errors?.Identities?.[index]?.Number
                                              ?.status
                                              ? "is-invalid form-control"
                                              : "form-control"
                                          }
                                          placeholder="No"
                                          name="Number"
                                          value={
                                            formData.Identities[index].Number
                                          }
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Identities",
                                              index,
                                              "Number",
                                              ["required"]
                                            )
                                          }
                                          onBlur={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input",
                                              "Identities",
                                              index,
                                              "Number",
                                              ["required"]
                                            )
                                          }
                                        />
                                        {errors?.Identities?.[index]?.Number
                                          ?.status && (
                                            <span className="error">
                                              {
                                                errors?.Identities?.[index]
                                                  ?.Number?.message
                                              }
                                            </span>
                                          )}
                                      </td>
                                      <td>
                                        <Select
                                          className={
                                            errors?.Identities?.[index]?.Country
                                              ?.status
                                              ? "is-invalid"
                                              : ""
                                          }
                                          name="Country"
                                          value={
                                            formData.Identities[index].Country
                                          }
                                          menuPortalTarget={document.body}
                                          styles={tableSelectStyle}
                                          menuPlacement="top"
                                          options={[
                                            { label: "Select...", value: "" },
                                            ...issuingContry,
                                          ]}
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "dropdown",
                                              "Identities",
                                              index,
                                              "Country",
                                              ["required"]
                                            )
                                          }
                                        ></Select>
                                        {errors?.Identities?.[index]?.Country
                                          ?.status && (
                                            <span className="error">
                                              {
                                                errors?.Identities?.[index]
                                                  ?.Country?.message
                                              }
                                            </span>
                                          )}
                                      </td>
                                      <td>
                                        <CustomDatePickerIndex
                                          handleChangeWithIndex={
                                            handleChangeWithIndex
                                          }
                                          index={index}
                                          module="Identities"
                                          name="issueDate"
                                          value={
                                            formData.Identities[index].issueDate
                                          }
                                        ></CustomDatePickerIndex>
                                      </td>
                                      <td>
                                        <CustomDatePickerIndex
                                          handleChangeWithIndex={
                                            handleChangeWithIndex
                                          }
                                          index={index}
                                          module="Identities"
                                          name="expiryDate"
                                          value={
                                            formData?.Identities[index]
                                              ?.expiryDate || ""
                                          }
                                          minDate={
                                            formData.Identities[index].issueDate
                                          }
                                        ></CustomDatePickerIndex>
                                      </td>
                                      <td className="text-center">
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "10px",
                                            marginTop: "10px",
                                          }}
                                        >
                                          {/* Upload Icon */}
                                          <label
                                            htmlFor={`identity-file-${index}`}
                                            title="Upload File"
                                            style={{
                                              cursor: "pointer",
                                              margin: 0,
                                            }}
                                          >
                                            <i
                                              className="fa fa-cloud-upload"
                                              style={{
                                                fontSize: "14px",
                                                color: "#27568B",
                                              }}
                                            />
                                          </label>
                                          <input
                                            id={`identity-file-${index}`}
                                            type="file"
                                            accept=".jpg,.jpeg,.png,.pdf"
                                            onChange={(e) =>
                                              handleIdentityFileChange(e.target.files, index)
                                            }
                                            style={{ display: "none" }}
                                          />
                                          {/* View Icon */}
                                          {formData.Identities[index]?.IdentityFile && (
                                            <a
                                              href={
                                                typeof formData.Identities[index].IdentityFile === "string"
                                                  ? formData.Identities[index].IdentityFile
                                                  : formData.Identities[index].IdentityFilePreview
                                              }
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              title="View File"
                                            >
                                              <i
                                                className="fa fa-eye"
                                                style={{
                                                  fontSize: "14px",
                                                  color: "#27568B",
                                                  cursor: "pointer",
                                                }}
                                              />
                                            </a>
                                          )}
                                        </div>
                                      </td>
                                      <td className="text-center align-middle">
                                        <a
                                          // onClick={(e) =>
                                          //   handleChangeWithIndex(
                                          //     e,
                                          //     "remove",
                                          //     "Identities",
                                          //     index,
                                          //     ""
                                          //   )
                                          // }
                                          onClick={(e) =>
                                            handleShowModal(
                                              e,
                                              "remove",
                                              "Identities",
                                              index
                                            )
                                          }
                                          className="del_icon"
                                        >
                                          <i className="bi bi-trash"></i>
                                        </a>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Employment Details */}
                <div
                  className="tab-pane fade show"
                  id="employment"
                  role="tabpanel"
                  aria-labelledby="employment-tab"
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="row">
                          <p>
                            <button
                              className="custom-btn pull-right"
                              onClick={(e) =>
                                handleChangeWithIndex(
                                  e,
                                  "addRow",
                                  "employment_history",
                                  "",
                                  ""
                                )
                              }
                            >
                              <i className="bi bi-plus-circle"></i>
                            </button>
                          </p>
                          <div className="table-responsive poc-head rounded">
                            <table id="poctable_head" className="table table-bordered pr-form-table mb-0 mt-3 align-middle">
                              <thead id="thcolor" className="text-center">
                                <tr>
                                  <th style={{ width: "16%" }}>Organization Name</th>
                                  <th style={{ width: "15%" }}>Location</th>
                                  <th style={{ width: "12%" }}>Start Date</th>
                                  <th style={{ width: "12%" }}>End Date</th>
                                  <th style={{ width: "16%" }}>Position</th>
                                  <th style={{ width: "8%", textAlign: "center" }}>Offer Letter</th>
                                  <th style={{ width: "8%", textAlign: "center" }}>Salary Slip</th>
                                  <th style={{ width: "8%", textAlign: "center" }}>
                                    Relieving & Exp.
                                  </th>
                                  <th style={{ width: "5%" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {formData.employment_history &&
                                  formData.employment_history.map &&
                                  formData.employment_history.map(
                                    (line, index) => (
                                      <tr key={index}>
                                      <td>
                                        <input
                                          className={
                                            errors?.employment_history?.[index]?.OrganizationName?.status
                                              ? "is-invalid form-control"
                                              : "form-control"
                                          }
                                          type="text"
                                          name="OrganizationName"
                                          value={formData.employment_history[index].OrganizationName}
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input-submit",
                                              "employment_history",
                                              index,
                                              "OrganizationName",
                                              []
                                            )
                                          }
                                        />
                                        {errors?.employment_history?.[index]?.OrganizationName?.status && (
                                            <span className="error">
                                              {errors?.employment_history?.[index]?.OrganizationName?.message}
                                            </span>
                                          )}
                                      </td>
                                      <td>
                                        <input
                                          className={
                                            errors?.employment_history?.[index]?.Location?.status
                                              ? "is-invalid form-control"
                                              : "form-control"
                                          }
                                          type="text"
                                          name="Location"
                                          value={formData.employment_history[index].Location}
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input-submit",
                                              "employment_history",
                                              index,
                                              "Location",
                                              []
                                            )
                                          }
                                        />
                                        {errors?.employment_history?.[index]?.Location?.status && (
                                            <span className="error">
                                              {errors?.employment_history?.[index]?.Location?.message}
                                            </span>
                                          )}
                                      </td>
                                      <td>
                                        <div className={
                                            errors?.employment_history?.[index]?.StartDate?.status
                                              ? "is-invalid-date date-container"
                                              : "date-container"
                                          }>
                                          <CustomDatePickerIndex
                                            handleChangeWithIndex={handleChangeWithIndex}
                                            index={index}
                                            module="employment_history"
                                            name="StartDate"
                                            value={formData.employment_history[index].StartDate}
                                          ></CustomDatePickerIndex>
                                        </div>
                                        {errors?.employment_history?.[index]?.StartDate?.status && (
                                            <span className="error">
                                              {errors?.employment_history?.[index]?.StartDate?.message}
                                            </span>
                                          )}
                                      </td>
                                      <td>
                                        <div className={
                                            errors?.employment_history?.[index]?.EndDate?.status
                                              ? "is-invalid-date date-container"
                                              : "date-container"
                                          }>
                                          <CustomDatePickerIndex
                                            handleChangeWithIndex={handleChangeWithIndex}
                                            index={index}
                                            module="employment_history"
                                            name="EndDate"
                                            value={formData.employment_history[index].EndDate}
                                            minDate={formData.employment_history[index].StartDate}
                                          ></CustomDatePickerIndex>
                                        </div>
                                        {errors?.employment_history?.[index]?.EndDate?.status && (
                                            <span className="error">
                                              {errors?.employment_history?.[index]?.EndDate?.message}
                                            </span>
                                          )}
                                      </td>
                                      <td>
                                        <input
                                          className={
                                            errors?.employment_history?.[index]?.Position?.status
                                              ? "is-invalid form-control"
                                              : "form-control"
                                          }
                                          type="text"
                                          name="Position"
                                          value={formData.employment_history[index].Position}
                                          onChange={(e) =>
                                            handleChangeWithIndex(
                                              e,
                                              "input-submit",
                                              "employment_history",
                                              index,
                                              "Position",
                                              []
                                            )
                                          }
                                        />
                                          {errors?.employment_history?.[index]?.Position?.status && (
                                            <span className="error">
                                              {errors?.employment_history?.[index]?.Position?.message}
                                            </span>
                                          )}
                                      </td>
                                      <td className="text-center">
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                                          <label htmlFor={`employment-offer-${index}`} title="Upload Offer Letter" style={{ cursor: "pointer", margin: 0 }}>
                                            <i className="fa fa-cloud-upload" style={{ fontSize: "14px", color: "#27568B" }} />
                                          </label>
                                          <input id={`employment-offer-${index}`} type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={(e) => handleEmploymentFileChange(e.target.files, index, "OfferLetter") } style={{ display: "none" }} />
                                          {formData.employment_history[index]?.OfferLetter && (
                                            <a href={typeof formData.employment_history[index].OfferLetter === "string" ? formData.employment_history[index].OfferLetter : formData.employment_history[index].OfferLetterPreview } target="_blank" rel="noopener noreferrer" title="View Offer Letter">
                                              <i className="fa fa-eye" style={{ fontSize: "14px", color: "#27568B" }} />
                                            </a>
                                          )}
                                        </div>
                                      </td>
                                      <td className="text-center">
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                                          <label htmlFor={`employment-salary-${index}`} title="Upload Salary Slip" style={{ cursor: "pointer", margin: 0 }}>
                                            <i className="fa fa-cloud-upload" style={{ fontSize: "14px", color: "#27568B" }} />
                                          </label>
                                          <input id={`employment-salary-${index}`} type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={(e) => handleEmploymentFileChange(e.target.files, index, "SalarySlip") } style={{ display: "none" }} />
                                          {formData.employment_history[index]?.SalarySlip && (
                                            <a href={typeof formData.employment_history[index].SalarySlip === "string" ? formData.employment_history[index].SalarySlip : formData.employment_history[index].SalarySlipPreview } target="_blank" rel="noopener noreferrer" title="View Salary Slip">
                                              <i className="fa fa-eye" style={{ fontSize: "14px", color: "#27568B" }} />
                                            </a>
                                          )}
                                        </div>
                                      </td>
                                      <td className="text-center">
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                                          <label htmlFor={`employment-relieving-${index}`} title="Upload Relieving & Experience Letter" style={{ cursor: "pointer", margin: 0 }}>
                                            <i className="fa fa-cloud-upload" style={{ fontSize: "14px", color: "#27568B" }} />
                                          </label>
                                          <input id={`employment-relieving-${index}`} type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={(e) => handleEmploymentFileChange(e.target.files, index, "RelievingLetter") } style={{ display: "none" }} />
                                          {formData.employment_history[index]?.RelievingLetter && (
                                            <a href={typeof formData.employment_history[index].RelievingLetter === "string" ? formData.employment_history[index].RelievingLetter : formData.employment_history[index].RelievingLetterPreview } target="_blank" rel="noopener noreferrer" title="View Relieving & Experience Letter">
                                              <i className="fa fa-eye" style={{ fontSize: "14px", color: "#27568B" }} />
                                            </a>
                                          )}
                                        </div>
                                      </td>
                                      <td className="text-center" style={{ verticalAlign: "middle" }}>
                                        <a
                                          style={{ cursor: "pointer" }}
                                          onClick={(e) =>
                                            handleShowModal(
                                              e,
                                              "remove",
                                              "employment_history",
                                              index
                                            )
                                          }
                                          className="del_icon"
                                        >
                                          <i className="bi bi-trash"></i>
                                        </a>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Addtional Details */}
                 <div
                  className="tab-pane fade show"
                  id="additional"
                  role="tabpanel"
                  aria-labelledby="additional-tab"
                >
                  <div className="row">
                        <div className="col-sm-2">
                            <label className="form-label">Exp.(In Yrs)<span className="required">*</span></label>
                            <input
                              placeholder="Year Exp"
                              className="form-control text-end"
                              type="number"
                              name="TotalYearExp"
                              value={formData?.TotalYearExp}
                              onChange={(e) =>
                                handleChange(e, "TotalYearExp", "input")
                              }
                            />
                            {errors.TotalYearExp && (
                              <span class="error">{errors?.TotalYearExp}</span>
                            )}
                        </div>
                        <div className="col-sm-2">
                            <label className="form-label">Additional months<span className="required">*</span></label>
                            <input
                              placeholder="(Max:11 months)"
                              className="form-control text-end"
                              type="number"
                              name="TotalMonthExp"
                              value={formData?.TotalMonthExp}
                              max={11}
                              min={0}
                              onChange={(e) => {
                                if (e.target.value === "" || (Number(e.target.value) >= 0 && Number(e.target.value) <= 11)) {
                                  handleChange(e, "TotalMonthExp", "input");
                                }
                              }}
                            />
                            {errors.TotalMonthExp && (
                              <span class="error">{errors?.TotalMonthExp}</span>
                            )}
                        </div>
                        <div className="col-sm-2">
                            <label className="form-label">Total Exp.</label>
                            <input
                              type="text"
                              className="form-control"
                              readOnly
                              disabled
                              value={`${formData?.TotalYearExp !== "" && formData?.TotalYearExp !== null && formData?.TotalYearExp !== undefined ? formData.TotalYearExp : "0"} Yrs ${formData?.TotalMonthExp !== "" && formData?.TotalMonthExp !== null && formData?.TotalMonthExp !== undefined ? formData.TotalMonthExp : "0"} Months`}
                            />
                        </div>
                         <div className="col-sm-2">
                            <div className="">
                              <label className="form-label">Marital Status</label>
                              <Select
                                name="MaritalStatus_021"
                                options={[
                                  { value: "", label: "Select" },
                                  ...maritialStatusOptions,
                                ]}
                                // value={formData?.MaritalStatus_021}
                                value={maritialStatusOptions.find(
                                  (option) =>
                                    option.value === formData?.MaritalStatus_021
                                )}
                                onChange={(selectedOption, action) =>
                                  handleSelect(selectedOption, action.name)
                                }
                              />
                            </div>
                         </div>
                           {formData?.MaritalStatus_021 === 140 && (
                              <>
                                <div className="col-sm-2">
                                  <div>
                                    <label className="form-label">Spouse Name</label>
                                    <input
                                      placeholder="Spouse Name"
                                      className="form-control"
                                      type="text"
                                      name="SpouseName"
                                      value={formData?.SpouseName}
                                      onChange={(e) =>
                                        handleChange(e, "SpouseName", "input")
                                      }
                                    />
                                  </div>
                                </div>
        
                                <div className="col-sm-2">
                                  <div>
                                    <label className="form-label">Spouse D.O.B</label>
                                    <CustomDatePicker
                                      key={formData?.SpouseDOB ? "has-date" : "no-date"}
                                      name="SpouseDOB"
                                      id="SpouseDOB"
                                      placeholderText="DD-MMM-YYYY"
                                      className="form-control"
                                      value={formData?.SpouseDOB ||""}
                                      maxDate={null}
                                     // maxDate={formData?.SpouseDOB ? undefined : null}
                                      handleChange={(date) => handleChange(date, "SpouseDOB", "datepicker")}
                                    />
                                  </div>
                                </div>
                                <div className="row mt-3">
                  {formData?.MaritalStatus_021 === 140 && (
                      <>
                     <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Child 1 Name</label>
                        <input
                          placeholder="Child 1 Name"
                          className="form-control"
                          type="text"
                          name="Child1Name"
                          value={formData?.Child1Name}
                          onChange={(e) =>
                                        handleChange(e, "Child1Name", "input")
                                      }
                        />
                        {/* {errors.BranchID && (
                          <span class="error">{errors?.BranchID}</span>
                        )} */}
                      </div>
                    </div>
                     <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Child 1 D.O.B</label>
                        <CustomDatePicker
                          name="Child1DOB"
                          id="Child1DOB"
                          placeholderText="DD-MMM-YYYY"
                          readOnly={formData?.MaritalStatus_021 !== 140}
                          className="form-control"
                          value={formData?.Child1DOB ||""}
                          maxDate={null}
                          handleChange={(date) => handleChange(date, "Child1DOB", "datepicker")}

                        />
                      </div>
                    </div>
                     <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Child 2  Name</label>
                        <input
                          placeholder="Child 2 Name"
                          className="form-control "
                          type="text"
                          name="Child2Name"
                          value={formData?.Child2Name}
                          onChange={(e) =>
                                        handleChange(e, "Child2Name", "input")
                                      }
                          
                        />
                        {/* {errors.BranchID && (
                          <span class="error">{errors?.BranchID}</span>
                        )} */}
                      </div>
                    </div>
                     <div className="col-sm-2">
                      <div className="">
                        <label className="form-label">Child 2 D.O.B</label>
                        <CustomDatePicker
                          name="Child2DOB"
                          id="Child2DOB"
                          placeholderText="DD-MMM-YYYY"
                          readOnly={formData?.MaritalStatus_021 !== 140}
                          className="form-control"
                          value={formData?.Child2DOB || ""}
                          maxDate={null}
                          handleChange={(date) => handleChange(date, "Child2DOB", "datepicker")}
                        />
                      </div>
                    </div>
                    <div className="mt-3"></div>
                    </>
                    )}
                   </div>
                              </>
                            )}
                        <div className="col-sm-2">
                          <label className="form-label">
                            Blood Group <span className="text-danger">*</span>
                          </label>
                          <Select
                            name="BloodGroup"
                            options={[
                              { value: "", label: "Select" },
                              ...bloodGroupType,
                            ]}
                            value={bloodGroupType.find(
                              (option) =>
                                option.value === formData?.BloodGroup
                            )}
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name)
                            }
                          />
                          {errors?.BloodGroup?.status && (
                            <span className="error">
                              {errors?.BloodGroup?.message}
                            </span>
                          )}
                        </div>
                        <div className="col-sm-2">
                          <label className="form-label">
                            PF Nominee Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={
                              errors?.PFNomineeName?.status
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            name="PFNomineeName"
                            value={formData?.PFNomineeName || ""}
                            onChange={(e) =>
                              handleChange(e, "PFNomineeName", "input")
                            }
                            onBlur={(e) =>
                              handleChange(e, "PFNomineeName", "input")
                            }
                          />
                          {errors?.PFNomineeName?.status && (
                            <span className="error">
                              {errors?.PFNomineeName?.message}
                            </span>
                          )}
                        </div>
                        <div className="col-sm-2">
                          <label className="form-label">
                            PF Nominee Relation <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={
                              errors?.PFNomineeRelation?.status
                                ? "is-invalid form-control"
                                : "form-control"
                            }
                            name="PFNomineeRelation"
                            value={formData?.PFNomineeRelation || ""}
                            onChange={(e) =>
                              handleChange(e, "PFNomineeRelation", "input")
                            }
                            onBlur={(e) =>
                              handleChange(e, "PFNomineeRelation", "input")
                            }
                          />
                          {errors?.PFNomineeRelation?.status && (
                            <span className="error">
                              {errors?.PFNomineeRelation?.message}
                            </span>
                          )}
                        </div>
                        </div>
                      </div>
                    </div>

              <div className="container-fluid d-flex justify-content-end mt-5">
                <div className="mb-2">
                  {/* <button type="reset" className="btn-info me-2">
                    Cancel
                  </button> */}

                  <button
                    onClick={() => {
                      let isInvalid = false;
                      let obj = {};
                      let errorList = [];
                      let counts = {
                        "general-tab": 0,
                        "Contact-tab": 0,
                        "Qualification-tab": 0,
                        "Bank-tab": 0,
                        "attachment-tab": 0,
                        "identities-tab": 0,
                        "employment-tab": 0,
                        "additional-tab": 0,
                      };

                      const addError = (tabId, tabName, message, fieldKey, errorMsg) => {
                        isInvalid = true;
                        counts[tabId] = (counts[tabId] || 0) + 1;
                        errorList.push({ tabId, tabName, message });
                        if (fieldKey) obj[fieldKey] = errorMsg || message;
                      };

                      // 1. Validate fields from EmployeeSchema
                      for (let row of EmployeeSchema) {
                        let temp = validate(formData[row.name], row.rule, row.type, row.name, false);
                        obj[row.name] = temp;
                        if (temp.status) {
                          const tabInfo = FIELD_TAB_MAPPING[row.name] || { tabId: "general-tab", tabName: "General Details" };
                          addError(tabInfo.tabId, tabInfo.tabName, temp.message);
                        }
                      }

                      // 2. Profile Picture
                      if (!formData.ProfilePic) {
                        setProfilePicError("Profile picture is required.");
                        addError("general-tab", "General Details", "Profile picture is required");
                      } else if (formData.ProfilePic instanceof File && formData.ProfilePic.size / 1024 / 1024 > 1) {
                        setProfilePicError("Profile picture must be less than 1 MB.");
                        addError("general-tab", "General Details", "Profile picture must be less than 1 MB");
                      } else {
                        setProfilePicError("");
                      }

                      // 3. Qualifications (Min 3 required)
                      const quals = formData.Qualification || [];
                      if (quals.length < 3) {
                        addError("Qualification-tab", "Qualification", "Please add at least 3 qualifications (e.g. 10th, 12th, Graduation)");
                      } else {
                        quals.forEach((qual, i) => {
                          const qualType = qual.Type?.label || qual.Type || "";
                          if (!qualType) {
                            addError("Qualification-tab", "Qualification", `Qualification Type is required at row ${i + 1}`);
                          }
                          if (!qual.QualificationFile && !qual.QualificationFilePreview && !qual.FileName && !qual.FilePath) {
                            addError("Qualification-tab", "Qualification", `Document file is required for Qualification: ${qualType || 'Row ' + (i + 1)}`);
                          }
                        });
                      }

                      // 4. Bank Details
                      const bank = formData.employeebank?.[0];
                      if (!bank?.Bank) addError("Bank-tab", "Bank Details", "Bank name is required");
                      if (!bank?.AccountNo) addError("Bank-tab", "Bank Details", "Bank Account Number is required");
                      if (!bank?.IFSCCode) addError("Bank-tab", "Bank Details", "Bank IFSC Code is required");

                      // 5. Identities
                      const identities = formData.Identities || [];
                      if (identities.length === 0) {
                        addError("identities-tab", "Identity", "At least one Identity document is required");
                      } else {
                        identities.forEach((id, i) => {
                          const idType = id.Type?.label || id.Type || "";
                          if (!idType || !id.Name || !id.Number || (!id.Country?.value && !id.Country)) {
                            addError("identities-tab", "Identity", `Identity Type, Name, Number, and Country are mandatory at row ${i + 1}`);
                          }
                          if (!id.IdentityFile && !id.IdentityFilePreview && !id.FileName && !id.FilePath) {
                            addError("identities-tab", "Identity", `Document file is required for Identity: ${idType || 'Row ' + (i + 1)}`);
                          }
                        });
                      }

                      // 6. Attachments
                      if (!formData.employeeAttachments?.length) {
                        addError("attachment-tab", "Attachments", "At least one attachment file is required");
                      }

                      // 7. Experience
                      if (formData.TotalYearExp === "" || formData.TotalYearExp == null) {
                        addError("additional-tab", "Additional Details", "Years of experience is required (enter 0 if fresher)", "TotalYearExp");
                      }
                      if (formData.TotalMonthExp === "" || formData.TotalMonthExp == null) {
                        addError("additional-tab", "Additional Details", "Additional months of experience is required (enter 0 if fresher)", "TotalMonthExp");
                      }

                      setErrors(obj);
                      setTabErrorCounts(counts);

                      if (isInvalid) {
                        if (errorList[0]?.tabId) switchTab(errorList[0].tabId);

                        const tabGroups = errorList.reduce((acc, { tabName }) => {
                          acc[tabName] = (acc[tabName] || 0) + 1;
                          return acc;
                        }, {});

                        const summary = Object.entries(tabGroups)
                          .map(([tab, count]) => `${tab} (${count})`)
                          .join(", ");

                        toast.error(`Please fix ${errorList.length} required field(s) in: ${summary}`);
                        return;
                      }

                      setTabErrorCounts({});
                      setShow(true);
                    }}
                    disabled={submit ? true : false}
                    type="button"
                    className="custom-btn"
                  >
                    Preview
                  </button>
                </div>
              </div>
            </div>
          </form>
    <Modal 
  show={showModal} 
  onHide={() => setShowModal(false)} 
  centered
  backdrop="static"
  size="md"
>
  <div style={{
    borderRadius: "12px",
    backgroundColor: "#ffffff",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
    border: "none",
    overflow: "hidden",
  }}>
    {/* Header with Icon */}
    <Modal.Header style={{
      borderBottom: "none",
      justifyContent: "center",
      paddingBottom: "0",
      paddingTop: "32px",
      backgroundColor: "#ffffff",
    }}>
      <div style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}>
        <div style={{
          width: "44px",
          height: "44px",
          backgroundColor: "#fee2e2",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "12px",
          color: "#dc2626",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}>
          <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: "22px" }}></i>
        </div>
        
        {/* Title */}
        <h3 style={{
          fontWeight: "600",
          color: "#1f2937",
          fontSize: "20px",
          margin: "0",
        }}>
          Delete Confirmation
        </h3>
      </div>
    </Modal.Header>

    {/* Body */}
    <Modal.Body style={{
      backgroundColor: "#ffffff",
      padding: "4px 10px",
      fontSize: "15px",
      color: "#6b7280",
      textAlign: "center",
      lineHeight: "1.5",
    }}>
      Are you sure you want to delete this item? This action cannot be undone.
    </Modal.Body>

    {/* Footer */}
    <Modal.Footer style={{
      borderTop: "none",
      justifyContent: "center",
      padding: "14px",
      gap: "12px",
      backgroundColor: "#ffffff",
    }}>
      <button
        style={{
          backgroundColor: "#f3f4f6",
          border: "1px solid #e5e7eb",
          padding: "6px 18px",
          borderRadius: "8px",
          fontWeight: "500",
          color: "#374151",
          cursor: "pointer",
          fontSize: "14px",
          transition: "all 0.2s ease",
        }}
        onClick={() => setShowModal(false)}
      >
        Cancel
      </button>
      <button
        style={{
          backgroundColor: "#dc2626",
          border: "none",
          padding: "6px 18px",
          borderRadius: "8px",
          fontWeight: "500",
          color: "#ffffff",
          cursor: "pointer",
          fontSize: "14px",
          transition: "all 0.2s ease",
        }}
        onClick={async () => {
          await handleDelete();  // Wait for delete to complete
          setShowModal(false);  // Then close the modal
        }}
      >
     Delete
      </button>
    </Modal.Footer>
  </div>
</Modal>

          {/* Bootstrap Modal */}
          <Modal show={show} onHide={handleClose} size="lg" scrollable>
            <Modal.Header closeButton>
              <p style={{
        fontSize: '20px',
        fontWeight: '600',
        color: '#27568B',
        margin: '0'
      }}>User Details</p>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto' }}>
              <div ref={modalRef} style={{ overflowX: 'auto' }}>
                <table className="table table-bordered">
                  <thead id="thcolor">
                    <tr style={{ textAlign: "center" }}>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        Field
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        Value
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Title</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.Title?.label}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Full Name</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.FirstName} {formData?.MiddleName}{" "}
                        {formData?.LastName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Father's Name</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.FatherName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Mother's Name</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.MotherName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Gender</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.Gender?.label}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Date of Birth</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.DateOfBirth}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Mobile Numbers</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.MobileNo1}, {formData?.MobileNo2}
                      </td>
                    </tr>
                     <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>WhatsApp Number</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.WhatappNo}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Email</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {" "}
                        {formData?.PersonalEmail}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Total Exp.(In Yrs)</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {" "}
                        {formData?.TotalYearExp}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Additional months*</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {" "}
                        {formData?.TotalMonthExp}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Correspondence Address</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.CorrespondenceAddressPrint}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Permanent Address</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.PermanentAddressPrint}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Qualification</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.Qualification?.map((q, index) => (
                          <div key={index}>
                            <span className="fw-bold">{`${index + 1}).`}</span>{" "}
                            {q?.Type} {q?.Stream ? `in ${q?.Stream},` : ""} {" "}
                            {q?.Institute} {q?.University ? `(${q?.University}),` : ""} {q?.YearOfPassing}
                            {q?.Percentage ? `, ${q?.Percentage}%` : ""}
                            {(q?.QualificationFile || q?.QualificationFilePreview) && (
                              <span className="ms-2">
                                <a
                                  href={typeof q.QualificationFile === "string" ? q.QualificationFile : q.QualificationFilePreview}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="View Qualification Document"
                                >
                                  <i className="fa fa-paperclip" style={{ color: "#27568B" }} />
                                </a>
                              </span>
                            )}
                          </div>
                        ))}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Employment Details</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.employment_history?.map((emp, index) => (
                          <div key={index}>
                            <span className="fw-bold">{`${index + 1}).`}</span>{" "}
                            {emp?.OrganizationName} {emp?.Position ? `(${emp?.Position})` : ""}
                            {emp?.Location ? `, ${emp?.Location}` : ""}
                            {emp?.StartDate ? `, From: ${emp?.StartDate}` : ""}
                            {emp?.EndDate ? ` To: ${emp?.EndDate}` : ""}
                            {(emp?.OfferLetter || emp?.OfferLetterPreview) && (
                              <span className="ms-2">
                                <a
                                  href={typeof emp.OfferLetter === "string" ? emp.OfferLetter : emp.OfferLetterPreview}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="View Offer Letter"
                                >
                                  <i className="fa fa-paperclip" style={{ color: "#27568B" }} /> Offer
                                </a>
                              </span>
                            )}
                            {(emp?.SalarySlip || emp?.SalarySlipPreview) && (
                              <span className="ms-2">
                                <a
                                  href={typeof emp.SalarySlip === "string" ? emp.SalarySlip : emp.SalarySlipPreview}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="View Salary Slip"
                                >
                                  <i className="fa fa-paperclip" style={{ color: "#27568B" }} /> Salary Slip
                                </a>
                              </span>
                            )}
                            {(emp?.RelievingLetter || emp?.RelievingLetterPreview) && (
                              <span className="ms-2">
                                <a
                                  href={typeof emp.RelievingLetter === "string" ? emp.RelievingLetter : emp.RelievingLetterPreview}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="View Relieving Letter"
                                >
                                  <i className="fa fa-paperclip" style={{ color: "#27568B" }} /> Relieving
                                </a>
                              </span>
                            )}
                          </div>
                        ))}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Identity</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.Identities?.map((id, index) => (
                          <div key={index}>
                            <span className="fw-bold">{`${index + 1}).`}</span>{" "}
                            {id?.Type?.label}: {id?.Name} {id?.Number ? `(${id?.Number})` : ""}
                            {id?.Country?.label ? `, ${id?.Country?.label}` : ""} 
                            {id?.issueDate ? `, Issue Date: ${id?.issueDate}` : ""}
                            {(id?.IdentityFile || id?.IdentityFilePreview) && (
                              <span className="ms-2">
                                <a
                                  href={typeof id.IdentityFile === "string" ? id.IdentityFile : id.IdentityFilePreview}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="View Identity Document"
                                >
                                  <i className="fa fa-paperclip" style={{ color: "#27568B" }} />
                                </a>
                              </span>
                            )}
                          </div>
                        ))}
                      </td>
                    </tr>
                     <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Bank Details</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.employeebank?.map((q, index) => {
                          const bankName =
                            bankOptions.find((bank) => bank.value === Number(q?.Bank))?.label || "N/A";

                          return (
                            <div >
                              Acc.Holder Name:-{[formData?.FirstName, formData?.LastName].filter(Boolean).join(" ")} , Bank Name: {bankName} , A/C: {q?.AccountNo} , IFSC: {q?.IFSCCode} ,Branch: {q?.Branch}
                            </div>
                          );
                        })}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Additional Details</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                       {[
                      formData?.SpouseName && `Spouse Name: ${formData.SpouseName}`,
                      formData?.SpouseDOB && `Spouse DOB: ${formData.SpouseDOB}`,
                      formData?.Child1Name && `Child1 Name: ${formData.Child1Name}`,
                      formData?.Child1DOB && `Child1 DOB: ${formData.Child1DOB}`,
                      formData?.Child2Name && `Child2 Name: ${formData.Child2Name}`,
                      formData?.Child2DOB && `Child2 DOB: ${formData.Child2DOB}`,
                      formData?.BloodGroup && `Blood Group: ${bloodGroupType.find((o) => o.value == formData.BloodGroup)?.label || formData.BloodGroup}`,
                      formData?.PFNomineeName && `PF Nominee Name: ${formData.PFNomineeName}`,
                      formData?.PFNomineeRelation && `PF Nominee Relation: ${formData.PFNomineeRelation}`,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Emergency Name</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.EmergencyContactName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Emergency Contact Relation </strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.EmergencyContactRelation}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Emergency PhoneNo </strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.EmergencyPhoneNo}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        <strong>Attachments</strong>
                      </td>
                      <td style={{ border: "1px solid black", padding: "8px" }}>
                        {formData?.employeeAttachments?.map((file, index) => {
                          // Generate a file URL if the file is newly uploaded (without a FilePath)
                          const fileUrl = file?.FilePath
                            ? file.FilePath
                            : file?.file
                              ? URL.createObjectURL(file.file)
                              : null;

                          return (
                            <div key={index}>
                              <span className="fw-bold">{`${index + 1
                                }).`}</span>{" "}
                              {fileUrl ? (
                                <a
                                  href={fileUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-primary text-decoration-underline"
                                >
                                  {file.FileName}
                                </a>
                              ) : (
                                <span>{file.FileName}</span> // Display name if no URL is available
                              )}
                            </div>
                          );
                        })}
                      </td>
                    </tr>
                  </tbody>
                </table>{" "}
              </div>
              <div>
                <input
                  className="form-check-input"
                  type="checkbox"
                  onChange={() => setAcknowledge(!acknowledge)}
                />
                <span>
                  {" "}
                  I confirm that the documents submitted are accurate and valid. I understand that submission of any invalid or forged documents will lead to immediate blacklisting.
                </span>
              </div>
            </Modal.Body>
            <Modal.Footer>
              
              <Button
                className="custom-btn"
                onClick={(e) => handleSubmit(e)}
                disabled={acknowledge ? false : true}
              >
                {submit ? <FaSpinner class="sm-spinner" /> : "Submit"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    );
  }
};

export default AddEmployee;
